/**
 * Internationalization file for English
 */
const message = {
  // Common buttons
  common: {
    button_confirm: 'Confirm',
    button_ok: 'OK',
    button_save: 'Save',
    button_cancel: 'Cancel',
    button_search: 'Search',
    button_search2: 'Search',
    button_reset: 'Reset',
    button_add: 'Add',
    button_add2: 'Add',
    button_del: 'Delete',
    button_edit: 'Edit',
    button_view: 'View',
    button_record: 'Record',
    button_push: 'Push',
    button_import: 'Import',
    button_export: 'Export',
    button_batch_import: 'Batch Import',
    button_back: 'Back',
    button_refresh: 'Refresh',
    button_operate: 'Operation',
    button_save_and_return: 'Save and Return',
    button_open: 'ON',
    button_off: 'OFF',
    button_more_option: 'More',
    button_clone: 'Clone',
    button_next_step: 'Next',
    button_exportReport: 'Export Report',
    del_confirm_title: 'Confirm Deletion',
    del_config_tips1: 'You will delete all selected configurations. Please confirm.',
    del_config_tips2: 'You will delete all selected configurations, and these configurations will also be cleared from the devices. Please confirm.',
    push_range: 'Push Range',
    push_status: 'Push Status',
    finish_status: 'Status',
    config_name: 'Config Name',
    param_version: 'Version Number',
    version: 'Version',
    operate_tip: 'Tip',
    operation_success: 'Operation Successful',
    delete_success: 'Deletion Successful',
    export_task_tip:'The export operation can take a little time, and the results are displayed in Report >> Export Task',
    chunk_load_error_tip: 'Page resources failed to load. Please refresh and try again.'
  },
  menu: {
    my_device: 'Device Brief',
    data_center: 'Data Center',
    remote_clear_lockpass: 'Restore Default Setting',
    device_restore: 'Device Restore',
    address_manage: 'Location Management',
    restore_date_record: 'Restore factory records',
    remote_usage_record: 'Remote Log',
    remote_manage_menu: 'Remote Management',
    remote_app_manage: 'App Management',
    remote_configuration: 'Configuration Deployment',
    devicedistributionmanage: 'Device Ownership',
    sysCustomization: 'System Customization',
    devicedistribution: 'Device Distribution',
    devicedonate: 'Device Transfer',
    devicedonaterecord: 'Transfer Record',
    occupyScreen: 'Kiosk Mode',
    silentApp: 'Auto-Start App',
    customDesk: 'Customized Desktop',
    bootAnimation: 'Boot Animation',
    index: 'Location',
    dashboard: 'Partner Connect',
    usermanage: 'User Management',
    userinfo: 'User Information',
    userlist: 'User List',
    useredit: 'User Edit',
    useradd: 'Add a User',
    changepass: 'Change Password',
    organization: 'Organization Management',
    organizationlist: 'Organization List',
    organizationadd: 'Add Organization',
    organizationdetail: 'Organization Details',
    app: 'App Management',
    applist: 'App List',
    authorityManagement: 'Authority Management',
    otaParamManagement: 'OTA Param Management',
    apppublish: 'App Release',
    appshelf: 'App Shelving',
    onshelf: 'Shelved Apps',
    notonshelf: 'Unshelved Apps',
    appadd: 'Add App',
    appupdate: 'App Update',
    device: 'Terminal Management',
    device_management: 'Management',
    devicemonitor: 'Device Information Monitoring',
    fence: 'Electronic Fence',
    drawfence: 'Fence Drawing',
    deviceexport: 'Device Batch Import',
    deviceadd: 'Add Device',
    deviceedit: 'Edit Device',
    functionforbidden: 'Function Disable',
    configuration: 'Configuration Management',
    appcenter: 'App Center Configuration',
    thirdapp: 'Third-party App Configuration',
    notfound: 'Page Not Found',
    errorpage: 'Error Page',
    home: 'Dashboard',
    dataCenter: 'Data Center',
    deviceMap: 'Device Map',
    account_manage: 'Account Center',
    company_info: 'Company Information',
    personal_info: 'Personal Information',
    my_operator: 'Authorization Control',
    children_account: 'Sub-merchants',
    my_children_account: 'My Sub-merchants',
    app_market: 'App Market',
    menu_banner: 'Banner',
    menu_app_upload: 'App Upload',
    menu_inside_app: 'Internal Apps',
    menu_app_check: 'App Review',
    app_manage: 'App Management',
    app_detail: 'App Details',
    app_add: 'App Details',
    app_param_config: 'Parameter Configuration',
    app_deploy: 'App Deployment',
    app_version_manage: 'Version Management',
    app_manage_content: 'Management Content',
    device_app_info: 'Device App Information',
    device_life_cycle: "Device Lifecycle",
    remote_assistance: 'Remote Assistance',
    device_config: 'Device Configuration',
    my_boot_animation: 'My Boot Animation',
    group_manager: 'Group Management',
    remote_screen: 'Remote Desktop',
    after_sale_service: 'After Sale Center',
    apply_after_sale: 'Apply',
    service_progress: 'Progress',
    flowManagement: 'Flow Management',
    flow_manage: 'Flow Manager',
    flowLimitWarn: 'Flow Limit Warn',
    visitInfoStatistic: 'Visit Info Statistic',
    abnormalAlarmStatistics: 'Abnormal Alarm Statistics',
    organization_management: 'Merchant',
    manufacturer_management: 'Model Management',
    manufacturer_dvc_type: 'Device Type',
    device_detail:'Terminal Details',
    device_detail_tab:'Terminal Details Tab',
    device_tabs: 'Device Information',
    param_add: 'Add App Parameter',
    param_edit: 'Clone App Parameter',
    param_edit1: 'Edit App Parameter',
    param_view: 'View App Parameter',
    organization_management_another: 'Organization Management',
    organization_management_repository: 'Device Repository',
    opt: 'OTP',
    mas_list: "MAS List",
    policyManagement: 'Policy Management',
    configurationManagement: 'Configuration Management',
    basesetting: 'Base Setting',
    operation_log: 'Operation Log',
    authority_management: 'Authority Management',
    platform_settings: 'Platform Settings',
    ota: 'OTA',
    device_task: 'Terminal Task',
    occupy_screen: 'Occupy Screen',
    report: 'Report',
    device_conn_analysis: 'Terminal Connection Analysis',
    network_conn_analysis: 'Network Connection Analysis',
    device_location_change: 'Device Location Change',
    alive_device_analysis: "Device Alive",
    paramManage: 'Parameter Management',
    paramManage_dict: 'Parameter Dictionary',
    paramManage_manage: 'Parameter Management',
    log_manage: "Log Manage",
    deviceEMVLog: "Log",
    bulk_task: "Bulk Task",
    export_task: "Export Task",
    deviceApp_installStatistics: 'App installs',
  },
  // Login module
  login: {
    username: 'Username',
    usernametip: "Account/Email",
    password: "Password",
    verifycode: 'Verification Code',
    rememberMe: 'Remember Username',
    loginbtn: 'Login',
    register_btn: 'Register',
    platformName: 'Partner Platform',
    login_check_company_input: 'Please fill in the company information on the Merchant Information Management - Company Information page.',
    repeat_login: 'This account is already logged in. Force login?',
    login_password_overdue: 'The password has expired. Please set a new password!',
    login_password_expiring: 'The password will expire in less than seven days. Please update it as soon as possible!',
    simplePassword:'password is too simple to ensure enterprise security,please reset',
    numberLetterRepeatFiveTimes:'Do not include more than 5 duplicate Numbers or letters',
    fiveContinuousNumber:'Do not include more than 5 continuous Numbers',
    atLeastSixContainLetterNumber:'Passwords should have no less than 6 digits,with letters and numbers',
    updatebrowser : 'Please update the browser',
    password_rule: 'The password must contain at least one uppercase letter, one number, one special character, and be 8-20 characters long.',
    password_inconsistency: 'Passwords do not match.',
    password_old : 'Please enter the original password',
    password_new_more : 'Please enter the new password again',
    username_rule : 'Account does not match the rule',
    password_rule_1 : 'The password is 6-16 digits long and must contain letters and numbers',
    verifycode_empty: 'Please enter the verification code',
    email_rule : 'Please enter the correct email address',
    avatar_rule : 'The size of the avatar must not exceed 500KB',
    avatarupload: 'Avatar Upload',
    oldpassword: 'Current Password',
    confirmnewpassword: 'Repeat New Password',
    batchlogout_confim_tip: 'Confirm logout. Continue?',
    batchh_return_parent_account_tip: 'Confirm return to the parent merchant. Continue?',
    avatar_format_rule : 'Only upload files in format of jpg, jpeg',
    warning: {
      name: 'Warning Information',
      fence_item: 'Exceeded device fence.',
      ip_item: 'Abnormal login IP address.',
      no_data: 'No data',
      login_record_title: 'Abnormal Login IP Warning',
      login_record_time: 'Login Time',
      login_record_current: 'Current Login',
      login_record_last: 'Last Login',
      password_err_warning: 'Attempted login with incorrect password.',
    },
    register: {
      partner: 'Partner Platform',
      verify_identidy: 'Verify Identity',
      account: 'Merchant',
      active_success: 'Activation Successful',
      active_fail: 'Activation link has expired.',
      lock_tip1: 'Too many login attempts. The account has been locked.',
      lock_tip2: 'Click the button below to send an unlock email to the provided email address.',
      btn_send: 'Send Unlock Email',
      tip_sending: 'Sending email...',
      tip_send_success: 'Email sent successfully.',
      email_tip: 'Please enter an email address.',
      password_tip: 'Please enter a password.',
      password_again: 'Confirm Password',
      password_again_tip: 'Please confirm the password.',
      verify_code: 'Please enter the verification code.',
      register_now: 'Register Now',
      register_email_send_tip1: 'An activation email has been sent to your registered email address.',
      register_email_send_tip2: 'Please click the link in the email within 24 hours',
      register_email_send_tip3: 'to complete the registration.',
      register_email_check: 'Check Email Now',
      agree_service_items: 'Agree to Terms of Service',
      no_email_received: 'Did not receive the email?',
      register_email_again_send: 'Resend Email',
    },
    firstLogin: {
      title: 'Please reset your password.',
      relogin: 'Re-login',
      relogin_tip: 'After resetting the password, you need to log in again.',
     },
    function: {
      logout: 'Logout',
      changePic: 'Change Avatar',
      changePwd: 'Change Password',
      return_manage: 'Return to Parent Merchant',
    },
    reset: {
      register_password: 'Reset Password',
      email_reset_password: 'Email Reset',
      tel_reset_password: 'Phone Reset',
      email_check_reset_password: 'Email Verification',
      button_content_step1: 'Send Verification Code',
      again_send_code: 'Resend Verification Code',
      resend_code_again_after: 'Resend after',
      email_reset: 'Reset Email',
    },
  },
  // Home page
  dashboard: {
    users: 'User Count',
    devices: 'Device Count',
    device_total_num:"Total number of devices",
    alive_device:"Online Device",
    joined_in_seven_days:"Joined in seven days",
    device_abnormal_status:"Device Abnormal Status",
    device_need_charge:"Battery < 20%",
    device_disable:"Disable Device",
    device_offline:"Offline Devices",
    device_offline_over_forty_eight_hours:"Offline > 48h",
    device_report_over_forty_eight_hours:"Unreported > 48h",
    device_map:"Device Map",
    warn_log:"Warning Log",
    warn: "Warning",
    sn: "SN",
    org: "Organization",
    record_time: "Record Time",
    device_fence_warn_tip: "Device left the device fence.",
    alive_device_month:"Monthly Activity",
    alive_device_week:"Weekly Activity",
    alive_device_num:"Number of active devices",
    un_bind_device_num:"Total number of unbound devices",
    bind_device_num:"Total number of bound devices",
    un_bind_device_count:"Number of unbound devices",
    bind_device_count:"Number of bound devices",
    statistic: {
      device_status: 'Device Status Ratio',
      device_operator: 'Operator Distribution',
      operator_detail: 'Detail Information',
      device_status_detail: 'Device Details',
      system_version_distribution: 'Android System Version',
      OSVersion_distribution: 'OS Version Information',
      apps_installation: 'App Installation Details',
      apps_installed: 'Installed',
      apps_name: 'App Name',
      apps_device: 'Device Count'
    },
  },
  // App related
  app_market: {
    check: {
      auto_mode: 'Auto Review',
      manual_mode: 'Manual Review',
      wait_check: 'Pending Review',
      pass_check: 'Approved',
      refuse_check: 'Rejected',
      add_balcklist_tip: 'Add to review blacklist?',
      check_mode: 'Review Mode',
      view_black_list: 'View Blacklist',
      check_progress: 'Review Progress',
      putin_app_name: 'Enter App Name',
      app_name: 'App Name',
      app_version_code: 'App Version',
      app_version_name: 'Version Name',
      submit_user: 'Submitter',
      submit_time: 'Submission Time',
      progress: 'Progress',
      no_pass_check: 'Rejected',
      app_package: 'App Package',
      remove_app_blacklist: 'Remove from Blacklist',
      no_pass_tip: 'Review Result: App review rejected!',
      fail_reason: 'Reason for Failure:',
      no_check: 'Not Reviewed',
      ing_check: 'Under Review',
      check_pass: 'Review Approved',
      click_icon_tip: 'Click the icon to edit app information.',
      check_no_pass: 'Review Rejected',
      app_download: 'Download',
      apply_push: 'Apply',
      cancel_apply: 'Cancel Apply',
      wait_check_tip: 'Review may take 3-5 business days. Please be patient!',
      push_apply_confirmation: 'Release Application Confirmation',
      apply_confirmation_tip: 'After applying for release, the review may take 3-5 business days. Please be patient.',
      cancel_check_apply: 'Withdraw Review Application',
      cancel_apply_tip: 'The app is awaiting administrator review. Withdraw the application?',
      re_apply_check: 'Reapply',
      re_apply_confirmation: 'Reapply for review of this app?',
      has_shelf_app: 'Shelved Apps',
      app_unshelf: 'Unshelve App',
      no_shelf_app: 'Unshelved Apps',
      app_shelf: 'Shelve App',
      app_detail: 'Details',
      app_shelf_org: 'Group Shelving',
      app_org_select: 'Group Selection',
      add_inside_app: 'Add App',
      file_size: 'App Size',
      update: 'Update',
      app_version_note: 'Version Notes',
      version_update: 'Version Update',
      select_busstype: 'Select Industry Type',
      putin_app_check_note: 'Enter review comments.',
      to_blacklist: 'Add to Blacklist',
      download: 'Download',
      copy_tip: 'Confirm to clone this app configuration?',
      app_in_blacklist: 'App added to blacklist.',
      app_out_blacklist: 'App removed from blacklist. Please reapply for review.',
      type_chage: 'Enabling auto-review will automatically approve all app applications. Proceed with caution!',
      to_auto: 'Enable auto-review?',
      to_handle: 'Enable manual review?',
      select_apk: 'Click here to upload an APK file.',
    },
    // App deployment related
    appDeploy: {
      del: {
        tip1: 'Confirm Deletion',
        tip2: 'You will delete all selected configurations.Please confirm.'
      },
      table: {
        nopush: 'Not Pushed',
        yespush: 'Pushed',
        allpush: 'Global Push',
        partpush: 'Partial Push',
        inputorgname: 'Enter org or merchant name.',
      },
      record: {
        view: 'View Content',
        pushRange: 'View Push Range',
        name: 'Name',
        user: 'Operator',
        pushrange: 'Push Range',
        time: 'Operate time',
        operateRecord: 'Operation Record',
      },
      app_addTip: 'Select the app to deploy.',
      app_deploy_manage: 'App Deployment',
      app_white_list: 'App Whitelist',
      app_survival_list: 'App SurvivalList',
      to_deploy_app: 'Deploy App',
      tree_empty: 'No data',
      deploy_push_manage: 'Push Management',
      config_name: 'Config Name',
      version: 'Version:',
      deploy_schedule: 'Execution Progress',
      deploy_time_not_empty: 'Select deployment time.',
      deploy_must_input: 'Required',
      deploy_must_select: 'Required',
      deploy_install_mode0: 'Silent Installation',
      deploy_install_mode1: 'Notify User to Install After Download',
      deploy_select_app: 'App Selection',
      deploy_current: 'Deploy Now',
      deploy_select: 'Select Deployment Time',
      deploy_select_time: 'Select Time',
      deploy_app_mode: 'Deployment Method',
      deploy_app_interval: 'Deployment Time',
      app_deploy_manage_detail: 'View App Deployment',
      config_name_not_empty: 'Rule name cannot be empty.',
      deploy_type_not_empty:'Please select mode',
    },
    appSurvivalList: {
      name: 'Name',
      pushRange: 'Push Range',
      content: 'App Selection',
      app_name: 'Name',
      app_package: 'Package Name',
      add_app: "Add App",
      app_name_is_empty: "App name cannot be empty.",
      app_package_is_empty: "App package name cannot be empty.",
      app_content_is_have_one: "Keep at least one entry.",
      app_survivalList_name_is_empty: "App keep-alive list configuration name cannot be empty.",
      app_survivalList_push_group_is_empty: 'Push group cannot be empty.',
      app_survivalList_content_is_empty: "App keep-alive list content cannot be empty.",
      app_survivalList_check_app_name_is_empty: "Selected app name cannot be empty.",
      app_survivalList_check_app_package_is_empty: "Selected app package name cannot be empty.",
      survivalList_app: 'Keep-Alive List Apps',
      app_survivalList_name_duplication:'The name of the application survival list already exists'
    },
    appWhitelist: {
      name: 'Name',
      pushRange: 'Push Range',
      content: 'App Selection',
      app_name: 'Name',
      app_package: 'Package Name',
      add_app: "Add App",
      app_name_is_empty: "App name cannot be empty.",
      app_package_is_empty: "App package name cannot be empty.",
      app_content_is_have_one: "Keep at least one entry.",
      app_whitelist_name_is_empty: "App whitelist configuration name cannot be empty.",
      app_whitelist_push_group_is_empty: 'Push group cannot be empty.',
      app_whitelist_content_is_empty: "App whitelist content cannot be empty.",
      app_whitelist_check_app_name_is_empty: "Selected app name cannot be empty.",
      app_whitelist_check_app_package_is_empty: "Selected app package name cannot be empty.",
      app_whitelist_tip: "Tip",
      app_whitelist_tip1: "1. After enabling the app whitelist, non-whitelist apps will be uninstalled! Proceed with caution!",
      app_whitelist_tip2: "2. If manually installing new apps, please update the app whitelist; otherwise, app installation will fail.",
      whitelist_app: 'Whitelist Apps',
      whitelist_tip: 'Apps pushed to this group via app deployment or custom desktop.',

    },
    appManage: {
      no_select: 'Select at least one app.',
      no_select_org: 'Select the organizations to shelve!',
      param_version: 'Version Number',
      device_group_allDevice: 'All Devices',
      app_name: 'Name',
      enter_config_name: 'Enter rule name.',
      add_path: 'Path',
      enter_config_path: 'Format: /sdcard/MDM',
      add_param: 'Add Parameter',
      edit_param:'Edit Parameter',
      type_of_text: 'Text',
      type_of_switch: 'Switch',
      param_name: 'Parameter Name',
      param_type: 'Parameter Type',
      param_value: 'Parameter Content',
      param_remark: 'Remark',
      enter_param_name_tip: 'Enter parameter name.',
      enter_param_value_tip: 'Enter parameter content.',
      enter_param_remark_tip: 'Enter parameter remark.',
      import_param_title: 'Import Parameters',
      upload_param_config_tip: 'Select the file to upload.',
      download_template: 'Download Template',
      no: 'No',
      download_error_import_excel: 'Download Error Data',
      param_pic: 'Wallpaper',
      param_desk_method: 'Desktop Type',
      param_name_empty: 'Parameter name cannot be empty.',
      param_path_empty: 'Path cannot be empty.',
      param_name_duplicate: 'Duplicate parameter name.',
      config_name_empty: 'Name cannot be empty.',
      import_tmp_error: 'Import failed. Please use the correct template format.',
      param_list_empty: 'Parameter list cannot be empty.',
      app_param_error_fileName: 'Error Parameter Configuration',
      appurl: 'App Download URL',
      appIcon: 'App Icon',
      appIconCheckout: '(Size: ≤100KB, Format: PNG/JPG)',
      appIconCheckout_size: 'Size: ≤100KB',
      appIconCheckout_pix: 'Dimensions: 140*140 pixels',
      appIconCheckout_format: 'Format: PNG/JPG/JPEG',
      appDesc: "App Description",
      bussType: "Industry Category",
      apppackage: 'Package Name',
      appversion: 'Version',
      shelfrevise: 'Adjust',
      ShelfDvcType: 'Available Model',
      versionState: 'Version Description',
      appDescPic: 'Product Screenshot',
      appVersionCode: 'Version Code',
      appDownloadNum: 'Downloads',
      appproducer: 'Manufacturer',
      appdescmaxlength: 'Enter no more than 1000 characters!',
      appproducerLength: 'Enter no more than 100 characters!',
      device_type: "Device Type",
      app_delete_all: 'You will delete this app. Confirm deletion?',
      app_remarket: 'Note:',
      app_desc_pic_upload: 'Upload Image Description: ',
      app_desc_pic_checkout: '(Upload Size: 720*1280; Format: png, jpg; Size: no more than 5M)',
      uploadapk_tip : 'Click or drag your APK here and upload',
      uploadapk_tip2: 'Drag and drop the installation package here to upload',
      uploadapk_upload1: 'Preparing to upload: ',
      uploadapk_upload2: 'Uploading: ',
      uploadapk_has_upload: 'Uploaded files: ',
      app_delete_tip: 'Confirm to delete this app version. Continue?',
      app: 'App',
      app_delete_tip0: 'Please Notice : Application',
      app_del_tip: 'will be deleted. Proceed with caution. Apps already installed on devices will not be deleted.',
      shelfList_searchTip: 'App name/org name',
      shelfList_searchTip1: 'App name',
      param_clone: 'Parameter Clone',
      clone_tip: 'You will clone this parameter configuration. Continue?',
      param_name_length_exceed:'The length of the parameter name cannot exceed 50 characters',
      no_valid_params:'The parameter name or parameter type cannot be empty',
      device_warn_log:"Device Warn Log"
    },
    error: {
      apk_size_rule: 'APK file size must not exceed 1GB.',
      appname_rule: 'Length must be between 1 and 30 characters.',
      bussType_rule: "Industry category cannot be empty.",
      apk_format_rule: 'Only APK format files can be uploaded.',
    },
    alert: {
      appRepet1: 'Sorry! The APK you uploaded,',
      appRepet2: 'Already exists.',
      appRepet3: 'If this app indeed belongs to your company, please email',
      appRepetMail: "uhome{'@'}urovo.com",
      appRepet3_1: 'to claim the app. After successful claim, the app will be transferred to your account with all data retained.',
      appRepet4: 'Same-name apps',
      appRepet5: 'Claim email format:',
      appRepet6: 'Subject: Claim App',
      appRepet7: 'Email body: Claim App - Same-name app (package name), contact person, contact details. Attach the company business license and corresponding software copyright certificate.',
    },
    tip: {
      operation_fail_upload: 'File upload failed.',
      appDescPicSize: 'Image size must not exceed 5MB!',
      appDescFormatter: 'Upload images in the correct format.',
      appDescUploadError: 'Image upload error!',
      appAvatarSize: 'Image size must not exceed 100KB!',
      appAvatarNotNull: "App icon does not exist.",
      appDescNotNull: "Please upload app description images.",
      appDevTypeNotNull: "Select device types!",
      no_match: 'No matching data.',
      operation_fail: 'Operation failed.',
      newpassword: 'Set New Password',
      newpasswordtip: 'New password -- Requires re-login after update!',
      selectmoreone: 'Select at least one item.',
    },
  },
  // Organization management
  org_manage: {
    org: {
      orgTree: {
        title_create: 'Create Sub-organization (Merchant)',
        placeholder_filter: 'Enter org or merchant name',
        check_box_inter: 'Parent-child linkage',
        check_box_inter1: 'Select All',
        form_superiorOrgName: 'Parent Organization:',
        form_orgType: 'Organization Type:',
        form_orgType_SubOrganization: 'Sub-organization',
        form_orgType_Merchant: 'Merchant',
        form_orgName: 'Organization (Merchant) Name:',
        form_orgName_placeholder: 'Enter organization (merchant)',
        form_merchant_placeholder: 'Enter Merchant ID',
        form_admin_email: 'Admin Email:',
        form_admin_email_help: "This account can log in to the Merchant Terminal Management Platform. Default password",
        form_admin_email_placeholder: 'Enter admin email',
        form_contactsName: 'Contact:',
        form_contactsName_placeholder: 'Enter contact name',
        form_contacts_phone: 'Contact Phone:',
        form_contacts_phone_placeholder: 'Enter contact phone',
        form_address: 'Merchant Address:',
        form_address_placeholder: 'Enter merchant address',
        form_remarks: 'Remarks:',
        form_remarks_placeholder: 'Enter remarks',
        form_btn_create: 'Create',
        validate_msg_orgName: 'Enter sub-organization (merchant) name',
        validate_msg_orgName_too_long: 'Sub-organization (merchant) name cannot exceed 125 characters',
        validate_msg_email: 'Admin email is invalid. Please re-enter',
        validate_msg_email_required: 'Enter email address',
        validate_msg_merId: 'Merchant ID cannot exceed 32 characters',
        validate_msg_contactsName: 'Contact name cannot exceed 100 characters',
        validate_msg_contactsPhone: 'Enter correct phone format',
        validate_msg_address: 'Merchant address cannot exceed 100 characters',
        validate_msg_remarks: 'Remarks cannot exceed 100 characters',
        add_org_success: 'Organization (merchant) added successfully',
        detail_form_title: 'Organization Details',
        detail_form_bind_device: 'Bound Devices',
        detail_form_storage_device: 'Terminal Warehouse Devices',
        detail_form_orgName: 'Org Name:',
        detail_form_orgName_placeholder: 'Enter organization name',
        detail_form_merchantName: 'Merchant Name:',
        detail_form_merchantName_placeholder: 'Enter merchant name',
        detail_form_btn_delete_org: 'Delete',
        detail_form_btn_delete_merchant: 'Delete',
        detail_form_btn_create_child: 'Create Sub-org',
        detail_delete_error_title: 'Organization deletion failed',
        detail_delete_error_title_2: 'Merchant deletion failed',
        detail_delete_warning: 'Warning',
        detail_delete_msg_one: 'Delete organization (merchant)',
        detail_delete_msg_two: '. All configurations for devices in this organization (merchant) will be cleared, and devices will be automatically unbound and moved to the parent device warehouse. Confirm deletion?',
        detail_delete_success: 'Deletion successful',
        detail_update_success: 'Update successful',
        excel_title_upload: 'Batch Import Organizations (Merchants)',
        excel_download_excel: 'Download Excel Template',
        excel_tips_upload: 'Drag files or click here to upload',
        excel_title_error: 'Batch import failed',
        excel_table_rowAndCol: 'Row and Column',
        excel_table_reason: 'Error Reason',
        excel_table_title_1: 'Batch Unbind Devices',
        excel_table_column_sn: 'SN',
        excel_table_column_time: 'BindTime',
        excel_table_column_orgName: 'Organization Name',
        btn_batch_unbind: 'Unbind All',
        excel_download_template: 'Download Template',
        modal_batch_unbind_title: 'Warning',
        modal_batch_unbind_msg: 'After unbinding devices, all device data will be deleted. Proceed with caution',
      },
      expendRow: {
        dvcType: 'Model',
        orgAndMerchant: 'Merchant/Organization',
        status: 'Status',
        status_normal: 'Normal',
        status_forbidden: 'Disabled',
        push_org: 'Group Push',
        push_sn: 'TID/SN Push',
        config_valid: 'Effective',
        config_invalid: 'Ineffective',
        placeholder: 'Enter search keyword.',
      }
    },
    search: {
      device_type: 'Model:',
      device_sn: 'SN:',
      device_sn_placeholder: 'Enter SN to search',
      device_type_placeholder: 'Select device type',
      add_time: 'Storage Time:',
      add_time_bind: 'Bind Time:',
      add_time_placeholder: 'Select date',
      btn_search: 'Search',
    },
    add: {
      btn_add_one: 'Single Activation',
      modal_add_one: 'StoreOneDevice',
      form_org_name: 'Organization:',
      form_device_type: 'DeviceType:',
      form_device_type_placeholder: 'Select device type',
      form_device_sn: 'SN:',
      form_device_sn_placeholder: 'Please entry SN',
      form_device_tid: 'TID:',
      form_device_tid_placeholder: 'Please entry TID',
      form_device_remark: 'Remark:',
      form_device_remark_placeholder: 'Enter remarks',
      form_btn_add: 'Storage',
      form_btn_cancel: 'Cancel',

      validate_sn: 'Please input the sn',
      validate_sn_too_long: 'Length of sn should less than 50',
      validate_tid_too_long: 'Length of tid should less than 50',
      validate_remark_too_long: 'length of remark should less than 300',
      validate_manufacture: 'Please select manufacture',
      validate_device_type: 'Please select device type',

      add_success: 'Add to repository success',
    },
    table: {
      storage_time: 'Storage Time',
      bind_time: 'Bind Time',
      device_type: 'Device Type',
      operator: 'Operator',
      remark: 'Remarks',
    },
    bash: {
      btn_bash_storage: 'Batch Storage',
      modal_title_bash_storage: 'Batch Storage',
      modal_btn_download: 'Download Template',
      modal_btn_cancel: 'Cancel',
      excel_title_error: 'Batch import failed',
      excel_msg_success: 'Operation successful',
    },
    storageMove: {
      btn: 'Move Inventory',
      btn1: 'Batch Move',
      modal_title: 'Move Inventory to',
      modal_btn_move: 'Move',
      modal_btn_cancel: 'Cancel',
      modal_success: 'Inventory move successful',
    },
    deviceBind: {
      btn: 'Bind Device',
      btn1: 'Batch Bind',
      modal_title: 'Bind Device to',
      modal_btn_bind: 'Bind',
      modal_btn_cancel: 'Cancel',
      modal_btn_next: 'Next',
      modal_btn_pre: 'Previous',
      modal_step_1: 'Complete Device Information (Optional)',
      modal_step_2: 'Select Binding Entity',
      modal_success: 'Device binding successful.',
    },
    deviceUnbind: {
      btn: 'Unbind',
      tip: 'Tip',
      tip_msg: 'Unbinding devices will clear all configurations and move devices to the device warehouse. Confirm unbind?',
      btn_cancel: 'Cancel',
      success_msg: 'Unbind successful',
    },
    deviceDelete: {
      btn: 'Delete Device',
      btn1: 'Batch Delete',
      tip: 'Tip',
      tip_msg: 'Deleting devices will remove them from the system. Confirm deletion?',
      device_delete_temp_again: 'Reminder: Delete this device?',
      success_msg: 'Deletion successful',
      fail_msg: 'Deletion failed',
    },
    // Batch unbind devices
    batchUnbind: {
      btn_name: 'Batch Unbind',
      header_tip: 'Batch Unbind Devices',
    },
    uruploader: {
      tip1: 'Supported file type: ',
      tip3: 'Modifying the first row in template file will cause error',
      tip4: 'Template File uploaded should contain less than ',
      tip4_1: '60001 rows',
      ignore_err: 'Ignore error',
      ignore_err_selected: 'Selected: ',
      ignore_err_selected_tip: 'The program ignores erroneous data in the template and processes only the data that it can process',
      ignore_err_unselected: 'Unselected: ',
      ignore_err_unselected_tip: 'The program processes all template data only when it is correct',
      download: 'Download template file',
      batch_success: 'Successfully uploaded the file. You can view the import progress in Report>Batch Tasks',
      format_err: 'Only support file with suffix "xls" "xlsx"',
      size_err: 'Only support file size less than 10 M',
    },
  },

  // Device management
  device_manage: {
    sn: 'SN',
    dvc_type: 'Device Model',
    tid: 'TID',
    deviceStatus: 'Device Status',
    status: 'Status',
    devType: 'Model',
    property_agency: 'Ownership Organization',
    lastOnlineTime:'Last Online Time',
    queryLastOnlineTime:'LastOnlineTime',
    selectLastOnlineTime: 'Select date',
    device_task: 'Device Task',
    device_task_log_0: 'Terminal Task Log',
    operation: 'Operation',
    scan: 'View',
    scan_details: 'View Details',
    update_key: 'Update Key',
    update_title: 'Update Key',
    update_tip: 'Confirm to update the key?',
    update_key_success: 'Key updated successfully',
    to_order: 'Instruct operate',
    to_more:'More',
    manufacturer_name: 'Manufacturer',
    query_dvc_type: 'Model',
    mid: 'MID',
    utms_sn: 'SN',
    sysVersion: 'OS Version',
    seVersion: 'SE Version',
    ufsVersion: 'UFS Version',
    query_condition: 'Filter Conditions',
    device_list_count: 'Device List Total',
    tai: 'units',
    last_address: 'Location',
    export_btn: 'Export',
    export_file_name: 'Device List',
    query: 'Query',
    reset: 'Reset',
    device_tab_device_detail: 'Device Details',
    device_tab_latest_upload_time: 'Last Report Time:',
    device_tab_power: 'Battery',
    device_tab_power_consumption: 'Power Consumption',
    device_tab_device_apps: 'Device Apps',
    detection_time: 'Detection Date',
    detection_result: 'Detection Result',
    detection_exception: 'Exception Items',
    exception_item: 'Exception',
    skip_item: 'Skip',
    icc_exception: 'ICC',
    mag_exception: 'MAG',
    picc_exception: 'PICC',
    printer_exception: 'Printer',
    scanner_exception: 'Scanner',
    frontCamera_exception: 'Front Camera',
    rearCamera_exception: 'Rear Camera',
    detection_ok: 'Healthy',
    detection_no: 'Abnormal',
    detection_normal: 'Normal',
    hardware_detection: 'Hardware Detection',
    test_results: 'Test Results',
    test_results_1: 'Total detected ',
    test_results_item: ' items',
    test_results_2: 'Passed ',
    test_results_3: 'Skipped ',
    test_results_4: 'Exception ',
    device_no: 'SN',
    device_type: 'Model',
    option: 'Operation',
    download_log_file: 'Download Device Log',
    ram_dosage: 'RAM Usage',
    rom_dosage: 'ROM Total',
    data_flow: 'Data Flow',
    data_wifi_flow: 'WiFi Flow',
    data_sim1_flow: 'SIM1 Flow',
    used: 'Used',
    remain: 'Remaining',
    app_name: 'App Name',
    app_version_code: 'Version Code',
    app_package: 'Package Name',
    app_size: 'Size',
    system_app: 'System App',
    third_app: 'Third-party App',
    // Directive related
    order_device_operate: 'Device Operation',
    order_operate_los: 'Operation Log',
    operate_content: 'Operation Content',
    operate_time: 'Operate time',
    operator: 'Operator',
    browser: 'Browser',
    disable: 'Disable',
    enable: 'Enable',
    disableBtn: 'Disable',
    enableBtn: 'Enable',
    shutdown: 'Shutdown',
    restart: 'Restart',
    ring: 'Device Ring',
    ring_pwd: 'Password',
    ring_modal_total: 'Reminder',
    ring_modal_total1: 'The device will ring at maximum volume. Enter the password to exit.',
    ring_modal_total2: 'Exit Ring Password',
    ring_modal_total3: 'Enter 4-digit number.',
    ring_modal_total_true: 'Yes',
    ring_modal_total_false: 'No',
    device_reset: 'Factory Reset',
    get_device_logs: 'Extract Device Logs',
    remote_desk: 'Remote Desktop',
    clear_oprate: 'Clear Screen Lock Password',
    clp_tip: 'Clearing the password will not cause app data loss, but the password cannot be recovered. Continue or not??',
    confirm: 'Confirm',
    cancel: 'Cancel',
    device_status: 'Device Status',
    on_line: 'Online',
    off_line: 'Offline',
    failReason: 'Failure Reason',
    msg_status_publish_time: 'Push Time',
    msg_status_publish_status: 'Message Status',
    msg_status_publish: 'Sending',
    msg_status_delivered: 'In Transit',
    msg_status_acked: 'Arrived',
    msg_status_dropped: 'Dropped',
    msg_status_publish_col: 'Latest message',
    disable_tip: 'This operation will disable the device. Continue or not?',
    enable_tip: 'This operation will enable the device.Continue or not?',
    shutdown_tip: 'This operation will shut down the device. Continue or not?',
    restart_tip: 'This operation will restart the device. Continue or not?',
    ring_tip: 'This operation will make the device ring. Continue or not?',
    reset_tip: 'This operation will reset the device to factory settings. Continue or not?',
    get_log_tip: 'This operation will extract device logs. Continue or not??',
    remote_desk_tip: 'This operation will start the device remote desktop. Continue or not?',
    remote_desk_request_expired: 'Remote desktop request has expired. Please resend.',
    remote_desk_fail_reason: 'Remote desktop failed. Reason:',
    task_type: 'Type',
    task_name: 'Content',
    task_status: 'Execution Status',
    release_time: 'Release Time',
    execution_time: 'Execution Time',
    app_deploy: 'App Deployment',
    wifi_config: 'WiFi Configuration',
    apn_config: 'APN Configuration',
    function_config: 'Function Settings',
    param_config: 'Parameter Configuration',
    message_send: 'Message Push',
    fence_config: 'Geo Fence',
    custom_desktop: 'Custom Desktop',
    get_device_log: 'Extract Device Logs',
    occupy_screen_log: 'Occupy Screen App',
    boot_animation: 'Boot Animation',
    app_whitelist: 'App Whitelist',
    wifi_whitelist: 'WiFi Whitelist',
    auto_start_app: 'Default Startup App',
    app_uninstall: 'App Uninstall',
    policy_management: 'Policy Management',
    app_black_list: 'App Blacklist',
    lock_screen_password: 'Screen Lock Password',
    Advertisement: 'Advertisement Push',
    task_executing: 'Executing',
    task_executing_fail: 'Execution Failed',
    task_executing_success: 'Execution Successful',
    org_name: 'Merchant',
    device_task_log: 'Terminal Task Log',
    // Battery related
    power_mobile_network: 'Mobile Network Standby',
    power_screen: 'Screen',
    power_blueTooth: 'Bluetooth',
    power_system: 'System',
    phone_standby_power: 'Phone Standby',
    power_wifi: 'WiFi',
    current_power: 'Current Battery:',
    power_consumption_ratio: 'Power Consumption Ratio',
    power_consumption: 'Power Consumption',
    acquisition_time: 'Collection Time',
    power_recharge: 'Charging',
    power_discharge: 'Discharging',
    device_power: 'Battery',
    device_power_update_time: 'Update Time',
    device_position_info: 'Location Information',
    device_location: 'Device Location',
    device_historical_track: 'Historical Track',
    historical_track_start_date: 'Start Date',
    historical_track_end_date: 'End Date',
    historical_track_map_mode: 'Map Mode',
    historical_track_data_mode: 'Data Mode',
    data_mode_table_column_time: 'Time',
    data_mode_table_column_longitude: 'Longitude',
    data_mode_table_column_latitude: 'Latitude',
    data_mode_table_column_position: 'Location',
    historical_track_select_date_tip: 'Select time range.',
    historical_track_time: 'Time',
    current_location: 'Current Location',
    last_location: 'Last Location',
    code: 'Error Code',
    fileName: 'Log File',
    terminalTime: 'Terminal Time',
    uploadTime: 'Upload Time',
    inputErrorCode: 'Enter error code.',
    inputSN: 'Enter device SN.',
    inputTerminalTime: 'Select terminal time.',
    inputUploadTime: 'Select upload time.',
    btn_search: 'Search',
    businessType: 'Business Type',
    msg: 'Message',
    emvLog: 'EMV Log',
    triggerEvent: 'Trigger Event',
    file_distributions:'File Distribution',
    //wifi配置
    wifiConfig: {
      push_succcess: 'Push successful.',
      clone_tip_wifi: 'Tip',
      tab_name: 'WiFi Configuration',
      addOne: {
        btn: 'Add',
        btn1: 'Edit',
        modal_title: 'Add WiFi Configuration',
        modal_title1: 'Edit WiFi Configuration',
        form_name: 'Config Name',
        form_name_placeholder: 'Enter configuration name.',
        form_ssid: 'Service Set Identifier (SSID)',
        form_ssid_tip: 'WiFi name to connect.',
        form_network_hide: 'Hidden Network',
        form_network_hide_tip: 'Enable this when the target network is not open or not broadcasting signals.',
        form_safeType: 'Security Type',
        form_safeType_tip: 'Wireless network encryption type for connection.',
        form_password: 'Password',
        form_password_tip: 'Wireless network password.',
        qr_code_generate_tip: 'Fill in settings before generating QR code.',
        qr_code_generate: 'Generate QR Code',
        form_btn_cancel: 'Cancel',
        form_btn_confirm: 'Add',
        form_btn_confirm1: 'Edit',
        validate_name: 'Enter configuration name.',
        validate_name_too_long: 'Configuration name too long.',
        validate_ssid: 'Enter SSID.',
        validate_ssid_too_long: 'SSID too long.',
        validate_safe_type: 'Select security type.',
      },
      pushRecord: {
        btn_back: "Back",
        title_record: "Operation Record",
        table_btn_check: "View Content",
        table_btn_range: "View PushRange",
        table_column_name: 'Config Name',
        table_column_operator: 'Operator',
        table_column_version: 'Version Number',
        table_column_push_range: 'PushRange',
        table_column_operate_time: 'Operate time',
        table_column_operate: 'Operation',
      },
      tableColumn: {
        push_status_unpushed: 'Not Pushed',
        push_status_unpushed1: 'TID/SN Push',
        push_status_push: 'Pushed',
        btn_record: 'Record',
        column_config_name: 'Config Name',
        column_push_status: 'Push Range',
        column_finis_status: 'Status',
        operation: 'Operation',
        column_push_type_all: 'Global Push',
        column_push_type_part: 'Partial Push',
        query_finish_placeholder: 'Please enter the key world of organization name',
        query_finish_placeholder1: 'Please enter the key world of sn',
        query_finish_placeholder2: 'Please enter the key world of organization name, press enter to search',
        query_finish_placeholder3: 'Please enter the key world of sn，press enter to search',
        modal_title: 'Query Push Range',
        modal_table_column: 'Organization Name',
        modal_table_column2: 'Effective',
        modal_table_column1: 'SN',
        finish_status_modal_title: 'Status',
        finish_status_modal_search_placeholder: 'SN/Organization Name',
        finish_status_modal_re_push: 'Repush',
        finish_status_modal_re_push_msg: 'Re-Push config successful',
        finish_status_modal_export: 'Export Report',
        finish_status_modal_select_success: 'Execution Successful',
        finish_status_modal_select_failure: 'Execution Failed',
        finish_status_modal_select_unhandle: 'Not Executed',
        finish_status_modal_table_column_org: 'Organization Name',
        finish_status_modal_file_name_success: 'Execution Successful Device List',
        finish_status_modal_file_name_failure: 'Execution Failed Device List',
        finish_status_modal_file_name_unhandle: 'Not Executed Device List',
        push_btn: 'Push',
        push_modal_title: 'Select Push Range',
        push_modal_cancel: 'Cancel',
        push_modal_confirm: 'Push',
        push_modal_validate: 'Select at least one push range.',
        push_modal_validate1: 'Operation successful.',
        detail_modal_title: 'View Configuration Details',
        clone_btn: 'Clone',
        delete_modal_msg: 'Deleting this configuration will also clear it from the device. Continue deletion?',
        delete_modal_cancel: 'Cancel',
        delete_modal_confirm: 'Delete',
    },
      deleteBash: {
        btn: 'Delete',
        modal_title: 'Batch Delete Configuration',
        modal_tip: 'Deleting these configurations will also clear them from the devices. Continue deletion?',
        modal_btn_cancel: 'Cancel',
        modal_btn_confirm: 'Delete',
      },
    },
    //wifi白名单
    wifiWhitelist: {
      wifi_whitelist_setting: 'WiFi Whitelist Settings',
      ssid: 'SSID',
      pus_range: 'Push Range',
      version: "Version",
      status: 'Status',
      operate: 'Operation',
      not_push: 'Not Pushed',
      add_wifi_whitelist: 'Add WiFi Whitelist',
      whitelist_ssid: 'Whitelist SSID',
      whitelist_ssid_tip0: 'Enter whitelist SSIDs, separated by commas, e.g., WIFI11,WIFI22,WIFI33',
      wifi_whitelist_config_edit_tip: 'Edit WiFi Whitelist Settings',
      wifi_whitelist_config_history_push: 'WiFi Whitelist Historical Push Content',
      wifi_whitelist_config_push: 'WiFi Whitelist Push',
      push_wifi_whitelist_config_batch_tip: 'Push WiFi whitelist configurations. Push?',
      wifi_whitelist_select_group_error: 'Select a device group.',
      wifi_whitelist_ssid: 'Whitelist Network Name',
      wifi_whitelist_group_wifi_ssid: 'SSIDs in Group WiFi Configurations',
      wifi_whitelist_group_wifi_ssid_new: 'Manual Addition',
      wifi_whitelist_group_ssid_list: 'SSIDs in WiFi Configurations',
      wifi_whitelist_look_more: 'View More',
      wifi_whitelist_name_default: 'My WiFi Whitelist',
      wifi_whitelist_name_is_exists: 'Enter rule name.',
      wifi_whitelist_push_range_is_exists: 'Select push range.',
      wifi_whitelist_ssid_name_is_exists: 'Add whitelist WiFi network name.',
      wifi_whitelist_ssid_empty: 'No information.',
      already_push:'Pushed'
    },
    //apn配置
    apnConfig: {
      tab_name: 'APN Configuration',
      addOne: {
        modal_title_one: 'Add APN Configuration',
        modal_title_one1: 'Edit APN Configuration',
        modal_title_two: 'APN Configuration Details',
        form_config_name: 'Config Name',
        form_apn_name: 'APN Name',
        form_agent: 'Proxy',
        form_port: 'Port',
        form_username: 'Username',
        form_password: 'Password',
        form_server: 'Server',
        form_mmsagent: 'MMS Proxy',
        form_mmsport: 'MMS Port',
        form_authentication_type: 'Authentication Type',
        form_apn_type: 'APN Type',
        form_apn_protocol: 'APN Protocol',
        form_btn_ok: 'Add',
        form_btn_ok1: 'Edit',
        validate_port: 'Enter correct port number.',
        validate_config_name: 'Enter configuration name.',
        validate_apn_name: 'Enter APN name.',
        validate_apn: 'Enter APN.',
        validate_mcc: 'Enter MCC.',
        authentication_type_null: 'None',
        validate_mnc: 'Please input MNC',
      },
      delete: {
        title: 'Delete Configuration'
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not Pushed',
        view: 'View',
        config_name: 'Config Name',
        apn_name: 'APN Name',
        push_type: 'Push Range',
        push_status: 'Push Status',
        finish_status: 'Status',
        operation: 'Operation',
      }
    },
    //文件分发
    file_distribution: {
      view_title: 'View File Distribution',
      device_groupDevice_fileDistribution: 'Create File Distribution',
      device_groupDevice_fileDistribution1: 'Edit File Distribution',
      device_groupDevice_tip7: 'View push content',
      device_groupDevice_tip10: 'The above is the specified path for file storage on the device!',
      device_groupDevice_fileUpload: 'File Upload:',
      device_groupDevice_uploadFile: 'Upload File',
      device_groupDevice_tip8: 'File size ≤100M. Files cannot be withdrawn after distribution. Proceed with caution!',
      device_groupDevice_targetPath: 'Target Path:',
      device_groupDevice_fileRule: 'File Rule:',
      device_groupDevice_coverOriginal: 'Overwrite Original File',
      device_groupDevice_tip12: 'Notify the recipient after successful download.',
      device_groupDevice_tip15: 'Upload the file to be distributed!',
      device_groupDevice_tip16: 'Enter correct target path!',
      device_groupDevice_tip17: 'Enter configuration name!',
      operation_success: 'Operation successful.',
      file_send_size_rule: 'Import file must not exceed 100MB.',
      tab_name: "File Distribution",
      add: "Add",
      delete: "Delete",
      upload_file: 'File Upload',
      target_path: 'Target Path',
      file_rule: 'File Rule',
      cover_file: 'Overwrite Original File',
      tip_user: 'Notify the recipient after successful download.',
      config_name: 'Config Name:',
      download_file: 'Original File',
      enter_config_name: 'Enter rule name.',
      param_version:"Version Number:"
    },
    //功能设置
    function_setting: {
      default_name: 'Function Settings',
      column_name: 'Config Name',
      push_range: 'Push Range',
      push_status: 'Push Status',
      finish_status: 'Status',
      operation: 'Operation',
      add_modal_title: 'Add Function Settings',
      edit_modal_title: 'Edit Function Settings',
      view_function_title: 'View Function Settings',
      tab_name: 'Function Settings',
      add_rule: 'Add',
      delete_rule: 'Delete',
      view_functionSetting: 'View Function Settings',
      rule_name: "Rule Name:",
      fcSetting_home_disable: "Disable Home Key:",
      fcSetting_dropDown_disable: "Disable Status Bar:",
      fcSetting_bluetooth_disable: "Disable Bluetooth:",
      fcSetting_wifi_disable: "Disable WiFi",
      fcSetting_ThirdPartyApplicationInstallation_disable: "Disable Third-party App Installation:",
      fcSetting_usb_disable: "Disable USB:",
      fcSetting_input_disable: "Disable Input Method Popup:",
      button_confirm: 'Confirm',
      button_cancel: 'Cancel',
      operation_success: 'Operation successful.',
      function_ruleName: "Rule name cannot be empty.",
      yes: 'Yes',
      no: 'No',
      no_handle: "No Action",
      on: 'Enable',
      off: 'Disable',
      deploy_operation_success: 'Operation successful.',
      device_donaterecord_all: 'All',
      uploadapk_upload1 : 'Prepare for Upload: ',
      uploadapk_upload2 : 'Uploading: ',
      device_remote_rule_name: "Rule Name",
      device_remote_fcSetting_wifi_disable: "Disable WiFi:",
      device_remote_fcSetting_allow_uninstall: 'Allow Uninstall:',
      device_remote_fcSetting_allow_permission: 'Allow App Permissions:',
      device_remote_fcSetting_gms_disable: "Disable GMS:",
      device_remote_fcSetting_nfc_permission: 'Disable NFC:',
      device_remote_fcSetting_camera_permission: 'Disable Camera:',
      device_remote_fcSetting_camera_disable: "Disable Camera",
      customDeskNameNotSame: 'Configuration names cannot be duplicated.',
      function_pushRange: "Push range cannot be empty.",
      close: 'Close',
      device_sn: 'Device SN',
      reminder: 'Reminder',
      selectmoreone: 'Select at least one item.',
      setSilentAppModel: 'Set as Default Startup',
      silent_query_appname: 'Enter app name',
      devType: 'Model',
      time_input: 'Polling time must be an integer, minimum 5 minutes, and cannot exceed 24 hours (1440 minutes).',
      enterMessage: 'Enter push message.',
      device_tip:'Prompt',
      device_forbidden_tip : 'This operation will disable the device. Continue or not?',
      device_unforbidden_tip : 'This operation will make the device available. Continue or not?',
      param_version:"Version Number:"
    },
    //地理围栏
    address_fence: {
      tab_name: 'Geofence',
      rule_name: 'Rule Name',
      fences_range_lng: 'Fence Longitude',
      fences_range_lat: 'Fence Latitude',
      fences_range_radius: 'Fence Radius',
      meter: 'Meters',
      fence_switch: "Fence Switch",
      close: "Disable",
      open: "Enable",
      out_of_range_limit: 'Out of Range Limit',
      device_disabled: 'Device Disabled',
      add: 'Add',
      delete_rule: 'Delete',
      push_content111: 'Push Content',
      table_rule_name: 'Config Name',
      table_fence: 'Fence',
      table_push_range: 'Push Range',
      table_status: 'Status',
      table_operate: 'Operation',
      ring_pwd: 'Password must be 4 digits.',
      device_fence_cricle_center_lng: 'Fence center longitude must be a number between -180 and 180.',
      device_fence_cricle_center_lat: 'Fence center latitude must be a number between -90 and 90.',
      device_fence_cricle_center_radius: 'Fence radius must be a number > 0.',
      device_fence_circle_frequency_param_error: 'Frequency must be a positive integer.',
      device_fence_circle_name_param_error: 'Rule name cannot be empty.',
      device_fence_circle_mail_error: 'Invalid email format.',
    },
    //消息推送
    messagePush: {
      tab_name: 'Message Push',
      edit: 'Edit Message Push',
      addOne: {
        modal_title_one: 'Add Push Message',
        modal_title_two: 'Push Message Details',
        validate_config_name: 'Enter configuration name.',
        validate_message: 'Enter push message.',
        form_config_name: 'Config Name:',
        form_message: 'Push Message:',
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not Pushed',
        view: 'View',
        config_name: 'Config Name',
        push_message: 'Message Content',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',
        operation: 'Operation',
      }
    },
    //应用卸载
    unInstallDeviceApp: {
      tab_name: 'App Uninstall',
      addOne: {
        modal_title_one1: 'Edit Uninstall App',
        validate_config_name: 'Enter configuration name.',
        form_config_name: 'Config Name',
        form_message: 'Uninstall App',
        device_groupDevice_uninstallApp: 'Uninstall App. Only one app can be uninstalled at a time.',
        device_groupDevice_configName: 'Config Name:',
        device_groupDevice_uninstallType: 'Uninstall Method:',
        device_groupDevice_configName_input: 'Enter configuration name.',
        device_groupDevice_uninstallType1: 'Uninstall by App Name',
        device_groupDevice_uninstallType2: 'Uninstall by Package Name',
        device_groupDevice_tip5: 'Select app name',
        device_groupDevice_config_version:'Version:',
        device_groupDevice_tip3: 'Fill in the name of the application package to be uninstalled. Only one is allowed (for example: ffsdsssd.dasdasd.sadasd)',
        device_groupDevice_tip4: 'Please confirm the accuracy of the package name',
        device_groupDevice_appPackageName: 'App Package Name:',
        device_groupDevice_tip17: 'Please input the name of the app package to be uninstalled',
        device_groupDevice_tip18: 'Please select the name of the app to be uninstalled',
        device_groupDevice_appName:'App Name:',
        validate_message:'Please enter the application package name',
        validate_message_appname:'Please select the application name'
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not Pushed',
        view: 'View',
        config_name: 'Config Name',
        unInstallType: 'Uninstall Method',
        unInstallPackageName: 'Uninstall App',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',
        unInstallType_Name1: 'Uninstall by App Name',
        unInstallType_Name2: 'Uninstall by Package Name',
        operation: 'Operation',
      }
    },
    //密码下发
    lockScreenPassword: {
      tab_name: 'Password Distribution',
      add_password: 'Add Password Rule',
      edit_password: 'Edit Password Rule',
      view_password: 'View Password Rule',
      config_name: 'Config Name',
      password_type: 'Password Type',
      lock_screen_password: 'Screen Lock Password',
      dynamic_password: 'Dynamic Password',
      validate_config_name: 'Enter configuration name.',
      validate_password_null: 'Enter password.',
      validate_password: 'Enter 6-12 digit password.',
      select_both: 'Distribute Both',
      select_lock_screen_password: 'Distribute Screen Lock Password',
      select_dynamic_password: 'Distribute Dynamic Password',
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not Pushed',
        view: 'View',
        config_name: 'Config Name',
        lock_screen_password: 'Screen Lock Password',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',
        operation: 'Operation',
      }
    },
    //广告
    advertisement: {
      tab_name: 'Advertisement',
      edit: 'Edit Advertisement',
      addOne: {
        modal_title_one: 'Add Advertisement',
        modal_title_adv_details: 'Advertisement Details',
        form_adv_config_name: 'Config Name:',
        validate_form_adv_config_name: 'Enter configuration name.',
        validate_form_adv_image_header: 'Upload Image Header in JPG, PNG, or JPEG format.',
        validate_form_adv_image_slider: 'Upload Image Slider in JPG, PNG, or JPEG format.',
        viewAdvPic: 'View Image',
        form_adv_image_header: 'Image Header:',
        addSlider: 'Add Slider',
        deleteSlider: 'Delete',
        uploadImageHeader: 'Upload Header',
        uploadSliderPic: 'Upload Slider',
        adv_content_max_size_is_8: 'Maximum 8 sliders.',
        adv_content_is_have_one: 'At least one slider required.',
        adv_header_imge_size: 'Upload Image Header.',
        adv_slider_imge_size: 'Upload Image Slider.',
        upload_image_format_error:'Only images in jpg, png, and jpeg formats can be uploaded'
      },
      table: {
        push_modal_title_adv_details: 'Push Advertisement Details',
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not Pushed',
        view: 'View',
        config_name: 'Config Name',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',
        operation: 'Operation',
      }
    },
    //ota
    ota: {
      menu: {
        add_os: 'Upload OS Image',
        add_reg: 'Add',
        update_reg: 'Modify',
        push: 'Push',
        stop: 'Disable',
        enable: 'Pushed',
        disable: 'Disabled',
        toBePush: 'Pending Push',
        download_template: 'Download Template',
        records: 'View Upgrade Records',
      },
      data: {
        selectSn: 'Enter or select SN.',
        msgStatus: 'Message Record',
        yes: 'Yes',
        no: 'No',
        change_reg: 'Push Rule',
        push: 'Push',
        change_status: 'Change Status',
        status: 'Status',
        os_id: 'OS Number',
        dev_type: 'Device Type',
        records_os_type: 'OS Type',
        model: 'Model',
        standard: 'Standard',
        os_version: 'Version Number',
        language: 'Language',
        bag_type: 'Package Type',
        high_version: 'Base Version',
        upload_date: 'Upload Time',
        isForce: 'Force Update',
        isSilent: 'Silent Update',
        isImmediate: 'Immediate Update',
        period: 'Update Time Slot',
        remind: 'Update Reminder',
        remarks: 'Remarks',
        osUrl: 'OS Download URL',
        chinese: 'Chinese',
        english: 'English',
        change_status_success: 'Operation successful.',
        change_status_failed: 'Operation failed.',
        push_succcess: 'Effective and Pushed',
        return_tip: 'Tip',
        return_msg: 'Confirm to return?',
        clear_snRegMsg: 'Confirm to clear all SNs?',
        url: 'OS URL',
      },
      addos: {
        version_rules: 'Version Rules',
        view_version_tips: 'View Rules',
        basic_os: 'Base OS Version',
        basic_os_tip: 'Incremental update package requires this field.',
        upload_package: 'Upload Package',
        upload_package_tip: 'Upload package (only .zip format supported).',
        complete_package: 'Complete Update Package',
        incremental_package: 'Incremental Update Package',
        timePick: 'Time Slot',
        datePick: 'Date Slot',
        save: 'Save',
        clear: 'Clear',
        back: 'Back',
        addos_success: 'OS image uploaded successfully.',
        validate_failed: 'Check if the input data is correct.',
        devType_msg: 'Device type cannot be empty.',
        model_msg: 'Hardware configuration cannot be empty.',
        standard_msg: 'Custom type cannot be empty.',
        osVersion_empty_msg: 'Version cannot be empty.',
        osVersion_msg: 'Invalid version format. Enter (Android version.YY.MMDD.xx) format!',
        bagType_empty_msg: 'Update package type cannot be empty.',
        path_empty_msg: 'Select file.',
        path_format_error_msg: 'Invalid file format.',
        file_too_large: 'File is too large and cannot exceed 8GB.',
        highVersion_empty_msg: 'Incremental update package requires base OS version.',
        select_empty: 'Select.',
        period_empty: 'Time slot cannot be empty.',
        remind_empty: 'When silent update is disabled, update reminder is required!',
        osVersion_format_msg: 'Enter correct version number first.',
        basic_os_error: 'Base OS version must be lower than OS version number.',
        // Backend error messages
        filename_notfound: 'Filename not found.',
        file_format_error: 'Invalid file format.',
        empty_file: 'Update package is empty. Cannot import.',
        unzip_file_failed: 'File extraction failed. Please reselect file.',
        upload_oss_failed: 'File upload to OSS failed.',
        file_transfer_failed: 'File conversion failed.',
        file_save_failed: 'File upload to server failed.',
        request_failed: 'Request failed.',
      },
      delos: {
        select_item: 'Select at least one item.',
        confirmed_del: 'Confirm Deletion',
        delete_success: 'Successfully deleted',
        item: 'items',
      },
      snReg: {
        push_by_sn: 'Push by SN',
        push_by_org: 'Push by Node',
        input_sn: 'Enter SN',
        add_sn: 'Add',
        import_sn: 'Import',
        back: 'Back',
        save: 'Save',
        selectAll: 'Select All',
        save_success: 'Save successful.',
        add_error_msg: 'Device is not under this organization or does not exist.',
        clear: 'Clear',
        added_sn: 'Added SNs',
        num: 'No.',
        action: 'Operation',
        delete: 'Delete',
        os_info: 'Current OS Information',
      },
      validateSN: {
        sn_duplicate: 'Duplicate.',
        sn_validate: 'SN can only contain letters and numbers and cannot be empty.'
      },
      importSN: {
        import_file: 'Import File',
        select_file: 'Select File (.txt file)',
        tips1: '*Only .txt files can be uploaded.',
        tips2: '*Recommend entering one SN per line.',
        tips3: '*If multiple SNs are entered in one line, separate them with ",".',
        fileMaxSize: 'File size exceeds limit.',
        fileUploadError: 'File upload error.',
        fileFormatError: 'Invalid file format.',
        import_success: 'Successfully imported',
        item: 'items',
        cancel: 'Cancel'
      },
      records: {
        osVersion: 'OS Version',
        updateResult: 'Update Result',
        btnSearch: 'Search',
        btnReset: 'Reset',
        btnBack: 'Back',
        recordedTime: 'Recorded Time',
        success: 'Success',
        failed: 'Failed',
      }
    },
    //设备生命周期
    deviceLifeCycle: {
      overview: 'Device Data Overview',
      overview_input: 'Entered Devices (units)',
      overview_register: 'Activated Devices (units)',
      search_form_sn: 'SN:',
      search_form_dvcType: 'Device Type:',
      search_form_inputTime: 'Entry Time:',
      search_form_registerTime: 'Activation Time:',
      search_form_btn_search: 'Search',
      search_form_btn_export: 'Export',
      table_column_sn: 'SN',
      table_column_sn_placeholder: 'Enter SN.',
      table_column_dvcType: 'Device Type',
      table_column_dvcType_placeholder: 'Select device type.',
      table_column_inputTime: 'Entry Time',
      table_column_registerTime: 'Activation Time',
      table_column_inputTime_createDate: 'Select entry time.',
      table_column_inputTime_registerDate: 'Select activation time.',
      table_column_orgName: 'Owner Organization(Merchant)',
    },
    //日志管理
    logManage: {
      log_add: "Create Log Task",
      sn: "SN",
      sn_tip: "Enter SN",
      device_type: "Model",
      device_type_tip: "Select a device type",
      task_time: "Task Time",
      task_time_tip: "Select time range",
      status: "Status",
      status_tip: "Select status",
      status_finish: "Completed",
      status_push: "Pushing",
      status_execution: "Executing",
      status_no_response: "Terminal No Response",
      status_forced_stop: "Forced Termination",
      status_file_is_not_exists: "File Does Not Exist",
      operate_download_log: "Download Log",
      operate_reset: "Retry",
      operate_force_stop: "Terminate Operation",
      table_sn: "SN",
      table_device_type: "Model",
      table_remark: "Device Remarks",
      table_log_type: "Log Type",
      table_create_time: "Create Time",
      table_start_time: "Start Time",
      table_end_time: "End Time",
      table_status: "Status",
      table_operate: "Operation",
      log_file_path: "File Path",
      log_type_utms: "UTMS Log",
      log_type_system: "System Log",
      log_type_file: "Specified File",
      log_type_utms_path: "/sdcard/UTMS/Log",
      log_type_system_path: "/sdcard/Ulog/logs/adb",
      log_type_utms_tip_1: "This operation will extract device logs. Continue?",
      log_type_utms_tip_2: "Log file upload may take some time. After completion, download from the log records.",
      log_type_system_start_time: "Start Time",
      log_type_system_continued_time: "Duration",
      log_type_system_log_main: "Main Log",
      log_type_system_log_main_tip: "(Kernel and root operation logs)",
      log_type_system_log_radio: "Radio Log",
      log_type_system_log_radio_tip: "(RF communication module logs)",
      log_type_system_log_system: "System Log",
      log_type_system_log_system_tip: "(OS logs)",
      log_type_system_log_events: "Events Log",
      log_type_system_log_events_tip: "(Event logs, e.g., touchscreen click events)",
      log_type_system_file_size: "File Limit",
      log_type_system_file_rule: "File Rule",
      log_type_system_file_rule_1: "Delete file after upload",
      log_type_system_file_rule_2: "Notify device after upload",
      log_type_system_start_time_type_tip: "Select start time.",
      log_type_system_continued_time_tip: "Enter duration.",
      log_type_system_continued_time_tip1: "Duration must be between 1-100.",
      log_type_system_continued_time_tip2: "Select time unit.",
      log_type_system_record_log_tip: "Select log record category.",
      log_type_system_file_size_tip: "Enter file limit.",
      log_type_system_file_size_tip1: "File limit must be between 0-200.",
      log_type_file_path: "Target Path",
      log_type_file_path_format: 'Format: /sdcard/MDM',
      log_type_file_path_tip: "The above is the specified path for file storage on the device.",
      log_type_file_file_rule: "File Rule",
      log_type_file_file_rule_1: "Delete file after upload",
      log_type_file_path_error_tip: "Enter target path.",
      log_type_file_path_error_tip1: "Invalid target path. Enter a valid path.",
      log_time_min: "Minute",
      log_time_hour: "Hour",
      log_time_day: "Day",
      add_table_sn: "SN",
      add_table_device_type: "Model",
      add_table_status: "Status",
      add_table_add_tip: "Select data from the left table.",
      add_table_remove_tip: "Select data from the right table.",
      modal_add_log: "Extract Device Logs",
      modal_select_device: "Select Device",
      modal_log_task: "Log Task",
      modal_button_add: "Add",
      modal_button_cancel: "Cancel",
      modal_button_next: "Next",
      modal_button_sure: "Confirm",
      device_status_on: "Online",
      device_status_off: "Offline",
      modal_tip_select_dvcId_empty: "No devices selected.",
      tip_content_forced_stop: "This operation will stop log collection. Continue?",
      tip_content_reset: "This operation will repush log collection. Continue?",
      log_download: 'Download',
      tip:"Tip",
    },
    remoteManage: {
      shutdown: 'Shutdown',
      restart: 'Restart',
      uninstallApp: 'Uninstall App',
      documentDistribution: 'File Distribution',
      deviceInfo: 'Device Information',
      nativeInfo: 'Local Information',
      dvcType: 'Model',
      snNumber: 'SN',
      sn_jd: 'SN',
      jd_device_info: 'Device Information',
      sysVersion: 'OS Version',
      seVersion: 'SE Version',
      ufsVersion: 'UFS Version',
      basebandVersion: 'Baseband Version',
      kernelVersion: 'Kernel Version',
      screenResolution: 'Screen Resolution',
      currentPosition: 'Current Position',
      dvcMemory: 'Device Memory',
      storage: 'Storage',
      SIMCardNum: 'SIM Card Serial Number',
      operator: 'Operator',
      IPAddress: 'IP Address',
      psam: 'PSAM Serial Number',
      unknown: 'Unknown',
      china_mobile: 'China Mobile',
      china_unicom: 'China Unicom',
      china_telecom: "China Telecom",
      china_tietong: "China Tietong",
      total_length_printed:'Total Length Printed',
      swipping_card_times:'Swipping Card Times',
      dip_insert_times:'Dip Insert Times',
      nfc_card_read_times:'NFC Card Read Times',
      front_camera_openTimes:'Front Camera Open Times',
      rear_camera_open_times:'Rear Camera Open Times',
    },
    remoteConfig: {
      function_control: 'Function Settings',
      ssid: 'SSID',
      wifi_whitelist_setting: 'WiFi Whitelist Settings',
      name: 'Name',
      type: 'Type',
      pus_range: 'Push Range',
      status: 'Status',
      execution_progress: 'Execution Progress',
      operate: 'Operation',
      select_push_range: 'Select Push Range',
      apn_name: 'APN Name',
      apn: 'APN',
      agent: 'Proxy',
      port: 'Port',
      user_name: 'Username',
      password: 'Password',
      server: 'Server',
      mmsc: 'MMSC',
      mms_agent: 'MMS Proxy',
      mms_port: 'MMS Port',
      mcc: 'MCC',
      mnc: 'MNC',
      authentication_type: 'Authentication Type',
      apn_type: 'APN Type',
      empty_null: 'None',
      apn_protocol: 'APN Protocol',
      not_push: 'Not Pushed',
      already_push: 'Pushed',
      qr_code_generate_tip: 'Fill in settings before generating QR code.',
      qr_code_generate: 'Generate QR Code',
      qr_code_generate_new_tip: 'Click to generate WiFi connection QR code. Devices can scan the QR code to connect to the network.',
      config_push: 'Push',
      config_edit: 'Edit',
      yes: 'Yes',
      no: 'No',
      add_wifi_whitelist: 'Add WiFi Whitelist',
      whitelist_ssid: 'Whitelist SSID',
      whitelist_ssid_tip0: 'Enter whitelist SSIDs, separated by commas, e.g., WIFI11,WIFI22,WIFI33',
      wifi_whitelist_config_edit_tip: 'Edit WiFi Whitelist Settings',
      wifi_whitelist_config_history_push: 'WiFi Whitelist Historical Push Content',
      wifi_whitelist_config_push: 'WiFi Whitelist Push',
      push_wifi_whitelist_config_batch_tip: 'Push WiFi whitelist configurations. Push?',
      wifi_whitelist_select_group_error: 'Select a device group.',
      wifi_whitelist_ssid: 'Whitelist Network Name',
      wifi_whitelist_group_wifi_ssid: 'SSIDs in Group WiFi Configurations',
      wifi_whitelist_group_wifi_ssid_new: 'Manual Addition',
      wifi_whitelist_group_ssid_list: 'SSIDs in WiFi Configurations',
      wifi_whitelist_look_more: 'View More',
      wifi_whitelist_name_default: 'My WiFi Whitelist',
      wifi_whitelist_name_is_exists: 'Enter rule name.',
      wifi_whitelist_push_range_is_exists: 'Select push range.',
      wifi_whitelist_ssid_name_is_exists: 'Add whitelist WiFi network name.',
      wifi_whitelist_ssid_empty: 'No information.',
    },
    manufacturer: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      enter_manufacturer_dvc_type: 'Maximum 25 characters.',
      remove_manufacturer_type_tip1: 'Confirm to delete',
      remove_manufacturer_type_tip2: 'model?',
      remove_manufacturer_tip1: 'Confirm to delete',
      manufacture_name_empty: 'Manufacturer cannot be empty.',
      dvc_type_empty: 'Device type cannot be empty.',
      dvc_type: 'Device Model:',
    },
    pushDisplay:{
      range:{
        group_push:"Group Push",
        sn_push:"SN Push",
        table:{
          sn:"SN",
          group_name:"Group Name",
          device_type:"Device Type",
        },
        tip:{
          input_sn:"Please enter SN",
        }
      },
      schedule:{
        execution_progress:"Execution Progress",
        status:{
          un_finish:"Undone",
          finish:"Completed",
          finish_failure:"Failed to execute",
          finish_stop:"Abort Release",
        },
        table:{
          sn:"sn",
          execution_status:"Execution Status",
          group_name:"Group Name",
          implementation:"Implementation",
        },
        tip:{
          search_status_tip:"Please select an execution state",
          search_sn_tip:"Please enter device SN",
        },
        button:{
          query:"Query",
          export_excel:"Export",
        }
      },
    },
    rule: {
      rule_name: 'Name',
      rule_version: 'Version Number',
      operate_user: 'Operator',
      version: 'Version Number',
      push_circle: 'Query Push Range',
      operate_time: 'Operate time',
      operate: 'Operation',
      view_push_content: 'View Content',
      pushRange: 'View Push Range',
      operate_record: 'Operation Record',
      record_return: 'Back',
      record_content: 'Push Content',
      record_modal_close: 'Close',
      app_deploy: 'App Deployment',
      unfinish_sn: 'Uncompleted SNs',
      unfinish_title: 'Status',
      sn: 'SN',
      dvc_org: 'Device Organization',
      schedule: 'Completion Rate',
      sn_own_group: 'Device Group',
      has_push_group: 'Organization Name',
      has_push_status: 'Pushed',
      will_push_status: 'Not Pushed',
    },
    warning: {
      fence_title: 'Device Fence Warning',
      device_lng: 'Device Longitude',
      device_lat: 'Device Latitude',
      fence_lng: 'Fence Longitude',
      fence_lat: 'Fence Latitude',
      fence_radius: 'Fence Radius',
    },
  },
  // System customization
  system_custom: {
    silent_app: {
      application_name: 'App Selection',
      default_config_name: 'Default Startup App',
      part_push: 'Partial Push',
      all_push: 'Global Push',
      has_pushed: 'Pushed',
      no_push: 'Not Pushed',
      table_column_config_name: 'Config Name',
      table_column_app_name: 'Default Startup App',
      table_column_push_range: 'Push Range',
      table_column_push_status: 'Push Status',
      table_column_finis_status: 'Status',
      table_column_operation: 'Operation',
      add_modal_title_name: 'Add Default Startup App',
      edit_modal_title: 'Edit Default Startup App',
      view_modal_title: 'View Default Startup App',
      add_rule: 'Add',
      delete_btn_rule: 'Delete',
      view_silent_app: 'View Default Startup App',
      rule_app_name: "Rule Name",
      silentApp_version: "Version Number",
      confirm_button: 'Confirm',
      cancel_button: 'Cancel',
      push_operation_success: 'Operation successful.',
      validate_configName_empty: "Rule name cannot be empty.",
      form_application_version: 'Version',
      validate_app_select_empty: 'Default startup app cannot be empty.',
      config_name_no_more_than: 'Rule name ≤32 characters.',
      modal2_title: 'Select Default Startup App',
      tableColumn: {
        push_status_unpushed: 'Not Pushed',
        push_status_unpushed1: 'TID/SN Push',
        push_status_push: 'Pushed',
        btn_record: 'Record',
        column_config_name: 'Config Name',
        column_push_status: 'Push Range',
        column_finis_status: 'Status',
        operation: 'Operation',
        column_push_type_all: 'Global Push',
        column_push_type_part: 'Partial Push',
        modal_title: 'Query Push Range',
        modal_table_column: 'Organization Name',
        modal_table_column2: 'Effective',
        modal_table_column1: 'SN',
        finish_status_modal_title: 'Status',
        finish_status_modal_search_placeholder: 'SN/Organization Name',
        finish_status_modal_re_push: 'Repush',
        finish_status_modal_re_push_msg: 'Re-Push config successful',
        finish_status_modal_export: 'Export Report',
        finish_status_modal_select_success: 'Execution Successful',
        finish_status_modal_select_failure: 'Execution Failed',
        finish_status_modal_select_unhandle: 'Not Executed',
        finish_status_modal_table_column_org: 'Organization Name',
        finish_status_modal_file_name_success: 'Execution Successful Device List',
        finish_status_modal_file_name_failure: 'Execution Failed Device List',
        finish_status_modal_file_name_unhandle: 'Not Executed Device List',
        push_btn: 'Push',
        push_modal_cancel: 'Cancel',
        push_modal_confirm: 'Push',
        push_modal_validate: 'Select at least one push range.',
        push_modal_validate1: 'Operation successful.',
        detail_btn: 'View',
    },
    },
    customDesk: {
      cusDeskType: 'Desktop Type',
      version: 'Version',
      name: 'Config Name',
      empty_custom_desk_tip: 'Enter configuration name.',
      empty_custom_desktop_tip: 'Enter desktop name.',
      stand_template: 'Standard Template',
      stand_template_tips: 'Note: Ensure the device has the Enterprise Desktop App installed when using the standard template.',
      custom_template_file: 'Custom Template File (Upload APK format, max 100M)',
      submit: 'Confirm Add',
      download_config: 'Download Configured File',
      default_cus_name: 'My Custom Desktop Rule',
      default_apk_name: 'My Package Name',
      upload_desktop_app: 'Upload custom desktop app.',
      upload_config_file: 'Upload configuration file.',
      admin_password_is_not_null:'Admin Password cannot be empty',
      app_package_is_not_null:'App Package Name cannot be empty',
      admin_password_error_tip: 'Admin password cannot contain Chinese.',
      upload_wallpaper_error: 'Upload wallpaper file.',
      add_package_name_tip: 'Multiple apps can be displayed on the desktop. Separate package names with ",".',
      custom_config_file: 'Upload configured enterprise mode profile.',
      custom_wallpaper: 'Upload wallpaper (only JPG, JPEG, PNG).',
      export_settings_property_json_description: 'Complete enterprise mode configuration on the template device and export. The exported file is saved in sdcard/Custom_Local_Server as settings_property.json. This JSON file can be pushed via UTMS.',
      customizeTemplate: 'Custom Template',
      normalTemplate: 'Standard Template',
      configMethod: 'Configuration Method',
      uploadWallpaper: 'Upload Wallpaper',
      configFileUpload: 'Upload Configuration File',
      wallpaperUpload: 'Upload Wallpaper',
      noWallpaperUpload: 'Do Not Upload Wallpaper',
      normalConfig: 'Standard Configuration',
      wallpaperName: 'Wallpaper',
      configName1: 'settings_property.json',
      desktopName: 'Desktop Name',
      adminPassword: 'Admin Password',
      desktopAppPackage: 'Desktop App Package Name',
      appIconSize: 'App Icon Size',
      small: 'Small',
      normal: 'Normal',
      nax: 'Large',
      oversized: 'Oversized',
      table_column_config_name: 'Config Name',
      table_column_apk_name: 'Desktop Name',
      add_modal_title_one1: 'Edit Custom Desktop',
      add_modal_title_two: 'Custom Desktop Details',
      add_modal_config_name: 'Config Name',
      add_modal_apk: 'Template file',
      add_modal_config: 'Configuration Method',
      custom_desk_add:'Custom Desktop Add',
      table_push_type:'Push Range',
      table_push_status:'Push Status',
      table_finish_status:'Status',
      table_operation:'Operation',
    },
    occupyScreen: {
      add: {
        title: 'Create Occupy Screen App',
        title1: 'Edit Occupy Screen App',
        form_name: 'Config Name',
        form_name_placeholder: 'Enter configuration name.',
        form_push_range: 'Push Range',
        form_push_range_placeholder: 'Select push range.',
        form_push_range_btn: 'Push Range',
        form_pwd: 'Unlock Pwd',
        form_pwd_placeholder: 'Enter unlock password (4 digits).',
        form_app: 'App Selection',
        form_cancel: 'Cancel',
        form_create: 'Create',
        form_edit: 'Edit',
        form_app_version: 'Version:',
        modal_title: 'Select Push Range',
        modal_cancel: 'Cancel',
        modal_confirm: 'Confirm',
        modal1_title: 'Select Occupy Screen App',
        modal1_search: 'App Name',
        modal1_select: 'Select App',
        validate_name_empty: 'Configuration name cannot be empty.',
        validate_orgName_empty: 'Push range cannot be empty.',
        validate_lockPwd_empty: 'Unlock password cannot be empty.',
        validate_lockPwd_er: 'Enter 4-digit password.',
        validate_app_empty: 'Occupy Screen app cannot be empty.',
        msg_add_success: 'Configuration added successfully.',
        msg_edit_success: 'Configuration edited successfully.',
      },
      table: {
        column_config_name: 'Config Name',
        column_occupy_app_name: 'Occupy Screen App',
        column_push_range: 'Push Range',
        column_status: 'Status',
        column_finish_status: 'Completion Rate',
        column_operation: 'Operation',
        column_push: 'Push',
        show_detail: 'View',
        show_modal_title: 'Occupy Screen Detail',
      },
    },
    bootAnimation: {
      tab_name: "Boot Animation",
      delete_rule: "Delete",
      btn_name_add: "Add",
      table_rule_name: "Config Name",
      table_rule_version: "Config Version",
      table_rule_push_range: "Push Range",
      table_rule_push_status: "Push Status",
      table_rule_finish_status: "Status",
      table_rule_create_time: "Create Time",
      table_rule_update_time: "Modification Time",
      table_rule_operate: "Operation",
      table_rule_animation_type: "Animation Type",
      push_range_group: "Group Push",
      push_range_tid_sn: "TID/SN Push",
      push_range_all: "Global Push",
      handle_status_unpushed: "Not Pushed",
      handle_status_pushed: "Pushed",
      animation_type_default: "Default Animation",
      animation_type_zip: "Upload ZIP",
      clone_tip: 'Confirm to clone this boot animation?',
      error_upload_file_format_size: "Upload ZIP file, max 20M.",
    },
    bootAni:{
      select_zip: 'Select ZIP Package',
      zip_rule: 'Rules',
      download_boot_temp: 'Download Template',
      boot_load_ing: 'The boot animation preview file is being generated. Please be patient. ',
      boot_join_ing: 'Loading...',
      zip_parse_fail: 'ZIP Parse Failed',
      zip_parse_fail_desc: 'ZIP parse failed. Please refer to the template and ZIP production rules for details. ',
      select_true: 'OK',
    },
    tip: {
      mustApk: 'Invalid file type. Upload APK file.',
      mustFile: 'Invalid file type. Upload JSON file.',
      cus_max_size: 'Maximum upload 100MB file.',
      fileTypeNotSupport:'File types are not supported',
    },
  },
  // Policy management
  policy_manage: {
    policyManagement: 'Policy Management',
    configurationManagement: 'Configuration Management',
    configureManage: {
      button: {
        upload_config: 'Upload Configuration',
        generate_barcode: 'Generate Barcode',
        publish: "Publish",
        delete_config: "Delete",
        cancel: "Cancel",
        save: "Confirm",
      },
      table: {
        table_name: 'Configuration Management',
        configName: 'Config Name',
        configRuleType: "Configuration Type",
        version: "Rule Version",
        pushType: "Push Range",
        pushStatus: "Status",
        executionProgress: "Execution Progress",
        createTime: "Create Time",
        updateTime: "Last Modification Time",
      },
      type: {
        scan_head: 'Scanner Settings',
        system: 'System Settings',
        scan_and_system: 'Scanner and System Settings',
      },
      status: {
        pushed: 'Published',
        not_pushed: 'Not Published',
      },
      modal: {
        head: 'Upload Configuration',
        barcode_generate: 'Barcode Generation',
        upload_file: 'Upload Configuration File',
        upload_file_tip: 'Supported format: txt',
        upload_file_format_tip: 'Invalid file format. Upload txt file.',
        upload_file_size_tip: 'Upload txt file ≤100KB.',
        barcode_tip: 'Open terminal U Stage to scan QR code and download configuration.',
        barcode_down: 'Download QR Code',
        delete_tip: "Delete selected configurations. Continue?",
        configName:'Config Name:',
        configRuleType:"Configuration Type:",
      },
      tip: {
        select_one_row:"Please select a rule",
        select_more_one_row:"Only one rule can be selected",
        select_delete_row:"Please select the data to delete",
        add_tip:"Please upload configuration file",
        top_tip_1:"1. Upload config: use UStage on the terminal to export the configuration file (UStage can be put on the shelf and downloaded through the app store – app list) and upload this configuration file. The upload configuration can be published through UTMS, and the terminal will automatically download and take effect after networking.",
        top_tip_2:"2. Terminal upload: use UStage on the terminal - upload to UTMS to synchronize the configuration of the device to the UTMS background. When using terminal upload, a rule will be automatically generated and can be published through UTMS.",
      }
    },
  },
  // Flow management
  flow_manage: {
    flowManagement: 'Flow Management',
    flow_manage: 'Flow Manager',
    flowLimitWarn: "Flow Limit Warn",
    flowManage: {
      device_type: 'Device Type',
      device_sn: 'Device SN',
      task_time_tip: "Select time range.",
      device_distribute_enterSn: 'Enter SN.',
      detail: 'Details',
      flowUsage: 'Flow Usage',
      appRank: 'App Ranking',
      groupRank: 'Organization/Merchant Ranking',
      exportReport: 'Export Report',
      date: 'Date',
      start_date: 'Start Date',
      end_date: 'End Date',
      totalUsage: 'Total Flow Consumption',
      dayUsagePerDvc: 'Daily Flow per Device',
      rank: 'Rank',
      org: 'Organization',
      parentOrg: 'Parent Organization',
      percent: 'Percentage',
      operate: 'Operation',
      appName: 'App Name',
      appPackage: 'App Package Name',
      periodTotalFlow: 'Period Total Flow',
      dvcNum: 'Device Count',
      periodDayFlow: 'Period Daily Flow',
      dvcDayFlow: 'Daily Flow per Device',
      periodOrgFlowUsage: 'Selected Organization Device Flow Usage',
      periodAppFlowUsageRank: 'Period Device App Flow Ranking',
      dvcSnCode: 'Device SN',
      selectOrg: 'Select Organization',
      unitMb: 'Unit: Mb',
      selectRankOrg: 'Select Organizations for Ranking',
      childGroupUsageDetail: 'Sub-organization Flow Details',
      currentOrg: 'Current Organization',
      selectTwoMoreOrg: 'Select at least 2 organizations.',
      nought: 'None',
      allOrg: 'All Organizations',
      selectDay: 'Select Date',
      startDayBeforeEndDay: 'Start date cannot be later than end date.',
      flowLimit: {
        tip: {
          search_tip: "Enter SN.",
        },
        modal: {
          flow_limit_tip: "Flow Limit Reminder",
          limit_tip: "When daily traffic exceeds the set value, record and alert",
          limited_amount_day: "Daily Limit",
          limit_error_tip: "Enter an integer between 1-9999.",
        },
        button: {
          limit_setting: "Limit Settings",
        },
        table: {
          sn: "SN",
          operate: "Operation",
          record_time: "Record Time",
          flow_use: "Daily Flow Usage",
          flow_limit: "Daily Limit",
          warn: "Warning",
          warn_tip: "Flow limit reached.",
        },
      },
    },
  },
  // Basic settings
  base_setting: {
    basesetting: 'Base Setting',
    platform_settings: 'Platform Settings',
    operation_log: 'Operation Log',
    authorityManagement: 'Permission Management',
    otaParamManagement: 'OTA Param Management',
    platformSetting: {
      power_flow_config: 'Power & Flow Configuration',
      high_precision_model: 'High Precision Mode',
      balance_model: 'Balanced Mode',
      energy_conservation_model: 'Power Saving Mode',
      custom_model: 'Custom Mode',
      push_setting: 'Push Settings:',
      using: 'Use',
      onUsing: 'Do Not Use',
      map_setting: 'Map Mode Setting:',
      preciseness: 'High Precision',
      energy_conservation: 'Power Saving',
      polling_time_setting: 'Polling Time Setting:',
      power_cache_frequency_setting: 'Battery Cache Frequency:',
      network_connection_frequency: 'Network Information Cache Frequency:',
      minute: 'Minute',
      data_cache_setting: 'Data Cache Settings',
      data_cache_setting_power_clean: 'Battery Information Validity',
      data_cache_setting_log_clean: 'Operation Log Validity',
      data_cache_setting_day: 'Day',
      data_cache_setting_minute: 'Minute',
      data_cache_setting_power_error_tip: 'Battery information validity: 1-360 days.',
      data_cache_setting_power_error_tip_empty: 'Battery information validity cannot be empty.',
      data_cache_setting_log_error_tip: 'Operation log validity: 30-360 days.',
      data_cache_setting_power_cache_frequency: 'Battery information cache frequency must be an integer ≤24 hours (1440 minutes).',
      data_cache_setting_net_connect: 'Network connection information cache frequency must be an integer ≤24 hours (1440 minutes).',
      data_cache_setting_log_error_tip_empty: 'Operation log validity cannot be empty.',
      platform_setting_submit: 'Apply',
    },
    operationLog: {
      search: {
        operator: 'Operator:',
        operator_placeholder: 'Enter operator.',
        module: 'Menu:',
        module_placeholder: 'Select menu.',
        operateTime: 'Operate Time:',
        operateTime_placeholder: 'Select operate time.',
        handle_status: 'Operation Result:',
        handle_status_placeholder: 'Select operation result.',
        btn_search: 'Search',
        btn_reset: 'Reset',
        operation_result_success: 'Success',
        operation_result_fail: 'Failure',
      },
      table: {
        operator: 'Operator',
        module: 'Menu',
        operatorTime: 'Operate Time',
        content: 'Operation Content',
        result: 'Operation Result',
        result_succ: 'Success',
        result_fail: 'Failure',
      }
    },
    authority: {
      form_header: 'Create Role',
      form_header_edit: 'Edit Role',
      role_name_label: 'Role Name:',
      role_name_error1: 'Role name is required.',
      role_name_error2: 'Role name cannot exceed 50 characters.',
      placeholder_1: 'Enter role name.',
      remark_label: 'Remarks:',
      is_default: 'Is Default:',
      remark_placeholder: 'Enter remarks.',
      remark_error1: 'Remarks cannot exceed 100 characters.',
      form_btn_cancel: 'Cancel',
      form_btn_OK: 'Confirm',
      is_default_yes: 'Yes',
      is_default_no: 'No',
      tab_user: 'User',
      tab_role: 'Role',
      tab_menu: 'Menu',
      user_form_account: 'Account',
      user_form_org: 'Org/Merchant',
      user_form_role: 'Pointed Roles',
      user_form_option: 'Operation',
      allocate_modal_header: 'Assign Role',
      allocate_form_role_name: 'Role Name',
      allocate_form_option: 'Operation',
      allocate_delete: 'Delete',
      allocate_cancel: 'Cancel',
      allocate_ok: 'Confirm',
      role_btn_create: 'Create',
      role_btn_delete: 'Delete',
      role_column_isDefault_true: 'Yes',
      role_column_isDefault_false: 'No',
      role_btn_edit: 'Edit',
      role_btn_allocate: 'Assign Menu',
      role_column_name: 'Role Name',
      role_column_default: 'Default Role',
      role_column_remark: 'Remarks',
      role_column_option: 'Operation',
      role_column_create_time: 'Create Time',
      role_column_update_time: 'Update Time',
      role_column_create_user: 'Creator',
      role_delete_title: 'Tip',
      role_delete_tip: 'Deleting this role will revoke permissions for users with this role. Confirm deletion?',
      role_allocate_modal_title: 'Assign Menu',
      role_allocate_modal_cancel: 'Cancel',
      role_allocate_modal_ok: 'Confirm',
      role_allocate_modal_error1: 'Select at least one menu.',
      role_allocate_title: 'Tip',
      role_allocate_tip: 'Assign selected permissions?',
      menu_tree_placeholder: 'Enter keyword to filter.',
      menu_tree_all: 'Select All',
      menu_tree_parent: 'Parent-Child Linkage',
      menu_detail_name: 'Menu Details:',
      menu_form_parent_code: 'Parent Menu Code:',
      menu_form_parent_name: 'Parent Menu Name:',
      menu_form__code: 'Menu Code:',
      menu_form_btn_select: 'Select Parent Menu',
      menu_form_path: 'Menu Path:',
      menu_form_auth: 'Validation String:',
      menu_form_remark: 'Remarks:',
      menu_form_i18: 'Internationalization String:',
      menu_form_order: 'Order Value:',
      menu_form_edit: 'Edit Menu',
      menu_form_create: 'Create Menu',
      menu_form_delete: 'Delete Menu',
      menu_form_error1: 'Select parent menu.',
      menu_form_edit_title: 'Tip',
      menu_form_edit_tip: 'Confirm to submit updates?',
      menu_form_delete_tip: 'Confirm to delete this menu?',
      menu_selector_title: 'Select Menu',
      menu_create_parent_placeholder: 'Select parent menu.',
      menu_create_parent_placeholder1: 'Select parent menu.',
      menu_create_path_placeholder1: 'Enter menu path.',
      menu_create_auth_placeholder1: 'Enter validation string.',
      menu_create_note_placeholder1: 'Enter remarks.',
      menu_create_i18_placeholder1: 'Enter internationalization string.',
      menu_create_order_placeholder: 'Enter order value.',
      menu_create_title: 'Create Menu',
      menu_form_path_val: 'Menu path cannot be empty.',
      menu_form_path_val1: 'Menu path cannot exceed 50 characters.',
      menu_form_auth_val: 'Menu validation string cannot be empty.',
      menu_form_auth_val1: 'Menu validation string cannot exceed 50 characters.',
      menu_form_i18_val: 'Internationalization string cannot be empty.',
      menu_form_order_val: 'Order value cannot be empty.',
      menu_form_order_val1: 'Order value must be numeric.',
      menu_form_i18_val1: 'Internationalization string cannot exceed 100 characters.',
      menu_form_remark_val1: 'Remarks cannot exceed 100 characters.',
      reset_password: 'Password',
      reset_password_repeat: 'Repeat Password',
      enter_password: 'Enter password.',
      password_rule: 'Password must contain at least one uppercase letter, one number, one special character, and be 8-20 characters long.',
      password_not_match: 'Passwords do not match.',
      user_unlocked_tip: 'Unlock account?'
    },
    userManage: {
      placeholder: 'Enter username for fuzzy search.',
      btn_search: 'Search',
      btn_reset: 'Reset',
      create: 'Add User',
      enable: 'Enable',
      disable: 'Disable',
      edit: 'Edit',
      reset_pwd: 'Reset Default Password',
      delete: 'Delete',
      col_status: 'Status',
      col_ip: 'Common IP',
      user_type: 'User Type',
      user_admin: 'Administrator',
      user_user: 'User',
      reset_title: 'Reset Confirmation',
      delete_tip: 'Delete selected user?',
      change_status_title: 'Toggle Confirmation',
      change_status_tip: 'Toggle switch status?',
      create_title: 'Create User',
      create_org: 'Belonging Organization',
      create_username: 'Username',
      create_password: 'Initial Password',
      create_role: 'Role',
      create_cancel: 'Cancel',
      create_confirm: 'Confirm',
      create_validate_password: 'Enter password.',
      create_validate_org: 'Select belonging organization.',
      create_validate_role: 'Select role.',
      edit_title: 'Edit User',
      reset_password_tip: 'This operation will reset the account to the entered password. Continue?',
      reset_password: 'Reset Password',
    },
    paramManagement: {
      add:'Add OTA Param',
      codeType:'Param Type',
      codeValue:'Param Value',
      createUser:'Create User',
      createDate:'Create Time',
      operation: 'Operation',
      codeType_msg:'Param Type is not null',
      codeValue_msg:'Param Value is not null',
      create_cancel: 'Cancel',
      DEVTYPE: 'Device Type',
      STANDARD: 'Standard',
      MODEL: 'Model',
      create_confirm: 'Confirm',
      delete: 'Delete',
      delete_title: 'Delete Confirmation',
      delete_tip: 'Delete selected OTA parameters. Continue?',
      codeType_placeholder:'Please select the param type'
    },
  },
  // Report
  report: {
    report: 'Report',
    device_location_change: 'Device Location Change',
    device_conn_analysis: 'Terminal  Connection Analysis',
    network_conn_analysis: 'Network Connection Analysis',
    alive_device_analysis: "Device Alive",
    deviceApp_installStatistics: 'App installs',
    deviceEMVLog: "Log",
    bulk_task: "Bulk Task",
    export_task: "Export Task",
    dvcLocate: {
      search_txt: 'Filter',
      search_org: 'Organization',
      search_time: 'Select Time',
      search_location: 'Location',
      search_close: 'Collapse',
      search_export: 'Export',
      search_search: 'Query',
      search_reset: 'Reset',
      header: 'Device Location Change',
      header_desc: 'Monitor device location changes for timely alerts and compliance checks.',
      column_history_location: 'View Historical Track',
      column_org: 'Ownership Organization',
      column_time: 'Record Time',
      column_tracking: 'Device Track',
      modal_cancel: 'Cancel',
      modal_ok: 'Confirm',
    },
    dvcConnInfo: {
      title:'Terminal Connection Exception Analysis',
      content:'For the equipment in the working environment, according to the PING packet situation, the data statistics and analysis of the wifi signal quality of the equipment are carried out, and the network status and equipment status in the working environment are effectively judged. Please note that frequent collection will affect the working use, and the recommended collection frequency > 1h.',
      query: {
        snOrTid: 'SN/TID:',
        networkDelayAvg: 'Average Delay:',
        exceptionTimes: 'Abnormal times:',
        location: 'Location:',
        orgName: 'Organization:',
        time: 'Select Time:',
      },
      orgName: 'Organization',
      ssid: 'SSID',
      networkDelayAvg: 'Average Delay (ms)',
      networkDelayMax: 'Maximum Delay (ms)',
      packetLossTimes: 'Packet Loss Count',
      exceptionTimes: 'Abnormal times',
    },
    netConnection: {
      file_name: 'Network Connection Analysis',
      search_channel: 'Channel',
      header: 'Network Connection Analysis',
      desc: 'Analyze network APs based on device network status, including signal strength and connection counts.',
      col_channel: 'AP Channel',
      col_avg: 'Average Signal Strength (dBm)',
      col_lowest: 'Minimum Signal Strength (dBm)',
      col_highest: 'Maximum Signal Strength (dBm)',
    },
    aliveDevice: {
      data_x_line: "X-axis Interval:",
      alive_device_situation: "Activity Status",
      alive_device_mouth_num: "Monthly Device Activity",
      alive_device_week_num: "Weekly Device Activity",
      alive_device_num: "Active Device Count",
      hour: "Hour",
      day: "Day",
      time_over_tips: "Selected date interval cannot exceed 7 days, when querying by hour",
    },
    deviceAppInstallStatistics: {
      file_name: "App installs",
      sn: "SN",
      org_to_sn: "Affiliation/Merchant",
      app_name: "App Name",
      app_version_name: "Version Name",
      export: 'Export',
      btn_search: 'Search',
      inputSn: 'Enter device SN',
      inputAppName: 'Enter app name',
      inputAppVersionName: 'Enter app version name',
      require_one_of_three: 'Please fill in at least one of SN, App name, or Version name before searching or exporting.',
    },
    bulkTask: {
      col_type: "Task Type",
      col_time_create: "Task Create Time",
      col_ignore_err: "Ignore Error",
      col_status: "Status",
      col_status_pending: 'Executing',
      col_status_complete: 'Import Successful',
      col_status_part_complete: 'Partially Imported',
      col_status_fail: 'Import Failed',
      col_status_error: 'Processing Exception',
      col_time_complete: 'Completion Time',
      import_success: 'Import/Success',
      operator: 'Operator',
      col_download_report: 'Download Error Report',
      col_option: 'Operation',
      val_yes: 'Yes',
      val_no: 'No',
      type_org_add: 'Organization Management_Batch Storage',
      type_sn_apn_push: 'APN Configuration_SN Push',
      type_sn_wifi_push: 'WiFi Configuration_SN Push',
      type_sn_function_push: 'Function Settings_SN Push',
      type_sn_appDeploy_push: 'App Deployment_SN Push',
      type_sn_param_push: 'Parameter Configuration_SN Push',
      type_sn_file_push: 'File Distribution_SN Push',
      type_sn_messagePush_push: 'Message Push_SN Push',
      type_sn_deviceFence_push: 'Geofence_SN Push',
      type_sn_customDesk_push: 'Custom Desktop_SN Push',
      type_sn_occupyScreen_push: 'Occupy Screen App_SN Push',
      type_sn_bootAnimation_push: 'Boot Animation_SN Push',
      type_sn_silentApp_push: 'Silent App_SN Push',
      type_sn_unInstall_push: 'App Uninstall_SN Push',
      type_sn_lockScreen_push: 'Lock Screen Password_SN Push',
      type_sn_advertisement_push: 'Advertisement_SN Push',
      type_sn_strategy_push: 'Configuration Management_SN Push',
      type_tid_apn_push: 'APN Configuration_TID Push',
      type_tid_wifi_push: 'WIFI Configuration_TID Push',
      type_tid_function_push: 'Function Settings_TID Push',
      type_tid_appDeploy_push: 'App Deployment_TID Push',
      type_tid_param_push: 'Parameter Configuration_TID Push',
      type_tid_file_push: 'File Distribution_TID Push',
      type_tid_messagePush_push: 'Message Push_TID Push',
      type_tid_deviceFence_push: 'Geo-Fencing_TID Push',
      type_tid_customDesk_push: 'Custom Desktop_TID Push',
      type_tid_occupyScreen_push: 'Full-Screen App_TID Push',
      type_tid_bootAnimation_push: 'Boot Animation_TID Push',
      type_tid_silentApp_push: 'Silent App_TID Push',
      type_tid_unInstall_push: 'App Uninstall_TID Push',
      type_tid_lockScreen_push: 'Lock Screen Password_TID Push',
      type_tid_advertisement_push: 'Advertisement_TID Push',
      type_tid_strategy_push: 'Configuration Management_TID Push',
      type_bulk_activation: 'Organization Device Warehouse_Bulk Activation',
      type_bulk_move: 'Organization Device Warehouse_Bulk Transfer',
      type_bulk_bind: 'Organization Device Warehouse_Bulk Binding',
      type_bulk_delete: 'Organization Device Warehouse_Bulk Deletion',
      type_bulk_unbind: 'Organization Device Warehouse_Bulk Unbinding',
      btn_search: 'Search',
    },
    exportTask: {
      task_tip: 'The export operation may take some time. Results will be displayed under {parMenu} >> {childMenu}',
      col_type: "Task Type",
      col_time_create: "Task Create Time",
      col_status: "Status",
      col_status_complete: 'Completed Successfully',
      col_status_fail: 'Execution Failed',
      col_time_complete: 'Completion Time',
      operator: 'Operator',
      col_download_report: 'Download Export Report',
      no_report: 'No Data',
      col_option: 'Operation',
      val_yes: 'Yes',
      val_no: 'No',
      btn_search: 'Search',
      type_abnormal_devices_need_charge: 'Abnormal Devices_Need Charging',
      type_abnormal_devices_disabled: 'Abnormal Devices_Disabled',
      type_abnormal_devices_offline: 'Abnormal Devices_Offline',
      type_abnormal_devices_offline_two_days: 'Abnormal Devices_Offline for Over 48 Hours',
      type_abnormal_devices_unreport_two_days: 'Abnormal Devices_No Data Uploaded for Over 48 Hours',
      type_app_param_unhandled: 'Parameter Configuration_Pending Devices',
      type_app_param_success: 'Parameter Configuration_Completed Devices',
      type_app_param_failure: 'Parameter Configuration_Failed Devices',
      type_app_deploy_unhandled: 'App Deployment_Pending Devices',
      type_app_deploy_success: 'App Deployment_Completed Devices',
      type_app_deploy_failure: 'App Deployment_Failed Devices',
      type_app_whitelist_unhandled: 'App Whitelist_Pending Devices',
      type_app_whitelist_success: 'App Whitelist_Completed Devices',
      type_app_whitelist_failure: 'App Whitelist_Failed Devices',
      type_app_survivalList_unhandled: 'App Keep-Alive List_Pending Devices',
      type_app_survivalList_success: 'App Keep-Alive List_Completed Devices',
      type_app_survivalList_failure: 'App Keep-Alive List_Failed Devices',
      type_terminal_detail: 'Device Details',
      type_wifi_unhandled: 'WIFI Configuration_Pending Devices',
      type_wifi_success: 'WIFI Configuration_Completed Devices',
      type_wifi_failure: 'WIFI Configuration_Failed Devices',
      type_apn_unhandled: 'APN Configuration_Pending Devices',
      type_apn_success: 'APN Configuration_Completed Devices',
      type_apn_failure: 'APN Configuration_Failed Devices',
      type_file_distribution_unhandled: 'File Distribution_Pending Devices',
      type_file_distribution_success: 'File Distribution_Completed Devices',
      type_file_distribution_failure: 'File Distribution_Failed Devices',
      type_function_setting_unhandled: 'Function Settings_Pending Devices',
      type_function_setting_success: 'Function Settings_Completed Devices',
      type_function_setting_failure: 'Function Settings_Failed Devices',
      type_wifi_whitelist_unhandled: 'WIFI Whitelist_Pending Devices',
      type_wifi_whitelist_success: 'WIFI Whitelist_Completed Devices',
      type_wifi_whitelist_failure: 'WIFI Whitelist_Failed Devices',
      type_device_fence_unhandled: 'Geo-Fencing_Pending Devices',
      type_device_fence_success: 'Geo-Fencing_Completed Devices',
      type_device_fence_failure: 'Geo-Fencing_Failed Devices',
      type_message_push_unhandled: 'Message Push_Pending Devices',
      type_message_push_success: 'Message Push_Completed Devices',
      type_message_push_failure: 'Message Push_Failed Devices',
      type_uninstall_app_unhandled: 'App Uninstall_Pending Devices',
      type_uninstall_app_success: 'App Uninstall_Completed Devices',
      type_uninstall_app_failure: 'App Uninstall_Failed Devices',
      type_lock_screen_password_unhandled: 'Lock Screen Password_Pending Devices',
      type_lock_screen_password_success: 'Lock Screen Password_Completed Devices',
      type_lock_screen_password_failure: 'Lock Screen Password_Failed Devices',
      type_advertisement_unhandled: 'Advertisement_Pending Devices',
      type_advertisement_success: 'Advertisement_Completed Devices',
      type_advertisement_failure: 'Advertisement_Failed Devices',
      type_device_lifecycle: 'Device Lifecycle',
      type_silent_app_unhandled: 'Silent App_Pending Devices',
      type_silent_app_success: 'Silent App_Completed Devices',
      type_silent_app_failure: 'Silent App_Failed Devices',
      type_custom_desk_unhandled: 'Custom Desktop_Pending Devices',
      type_custom_desk_success: 'Custom Desktop_Completed Devices',
      type_custom_desk_failure: 'Custom Desktop_Failed Devices',
      type_occupy_screen_unhandled: 'Full-Screen App_Pending Devices',
      type_occupy_screen_success: 'Full-Screen App_Completed Devices',
      type_occupy_screen_failure: 'Full-Screen App_Failed Devices',
      type_boot_animation_unhandled: 'Boot Animation_Pending Devices',
      type_boot_animation_success: 'Boot Animation_Completed Devices',
      type_boot_animation_failure: 'Boot Animation_Failed Devices',
      type_policy_management_unhandled: 'Configuration Management_Pending Devices',
      type_policy_management_success: 'Configuration Management_Completed Devices',
      type_policy_management_failure: 'Configuration Management_Failed Devices',
      type_company_flow: 'Data Usage Overview',
      type_device_app_flow: 'App Ranking',
      type_device_org_flow: 'Organization/Merchant Data Usage Ranking',
      type_device_org_flow_detail: 'Organization/Merchant Data Usage Ranking Details',
      type_device_location: 'Device Location Changes',
      type_device_conn_info: 'Terminal Connection Analysis',
      type_device_net_conn_analysis: 'Network Connection Analysis',
      type_device_alive_info: 'Device Activity Status',
      type_device_app_install_statistics: 'App Installation Statistics',
      type_device_ota_log: 'OTA Upgrade Log'
    },
  },
}
export default message
